@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package farmatch.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.StringResource

private object CommonMainString0 {
  public val accept_button: StringResource by 
      lazy { init_accept_button() }

  public val accept_confirm_notice: StringResource by 
      lazy { init_accept_confirm_notice() }

  public val accept_no_cancel_notice: StringResource by 
      lazy { init_accept_no_cancel_notice() }

  public val ad_update_error: StringResource by 
      lazy { init_ad_update_error() }

  public val ad_updated_success: StringResource by 
      lazy { init_ad_updated_success() }

  public val add_date_caps: StringResource by 
      lazy { init_add_date_caps() }

  public val add_favorites: StringResource by 
      lazy { init_add_favorites() }

  public val add_to_batch: StringResource by 
      lazy { init_add_to_batch() }

  public val address_label: StringResource by 
      lazy { init_address_label() }

  public val address_label_caps: StringResource by 
      lazy { init_address_label_caps() }

  public val address_row: StringResource by 
      lazy { init_address_row() }

  public val ads_deleted: StringResource by 
      lazy { init_ads_deleted() }

  public val all_filter: StringResource by 
      lazy { init_all_filter() }

  public val already_have_account_button: StringResource by 
      lazy { init_already_have_account_button() }

  public val any_period: StringResource by 
      lazy { init_any_period() }

  public val app_name: StringResource by 
      lazy { init_app_name() }

  public val apply_button: StringResource by 
      lazy { init_apply_button() }

  public val at_hours: StringResource by 
      lazy { init_at_hours() }

  public val attention: StringResource by 
      lazy { init_attention() }

  public val availabilities_saved: StringResource by 
      lazy { init_availabilities_saved() }

  public val availabilities_to_save: StringResource by 
      lazy { init_availabilities_to_save() }

  public val available_shifts: StringResource by 
      lazy { init_available_shifts() }

  public val back_nav: StringResource by 
      lazy { init_back_nav() }

  public val batch_availability_mgmt: StringResource by 
      lazy { init_batch_availability_mgmt() }

  public val batch_publish_mgmt: StringResource by 
      lazy { init_batch_publish_mgmt() }

  public val batch_published_success: StringResource by 
      lazy { init_batch_published_success() }

  public val birth_date_label: StringResource by 
      lazy { init_birth_date_label() }

  public val birth_place_label: StringResource by 
      lazy { init_birth_place_label() }

  public val born_at: StringResource by 
      lazy { init_born_at() }

  public val born_on: StringResource by 
      lazy { init_born_on() }

  public val call_button: StringResource by 
      lazy { init_call_button() }

  public val cancel_button: StringResource by 
      lazy { init_cancel_button() }

  public val cancel_match_button: StringResource by 
      lazy { init_cancel_match_button() }

  public val cancel_match_confirm_msg: StringResource by 
      lazy { init_cancel_match_confirm_msg() }

  public val cap_label: StringResource by 
      lazy { init_cap_label() }

  public val cap_label_short: StringResource by 
      lazy { init_cap_label_short() }

  public val citizenship_label: StringResource by 
      lazy { init_citizenship_label() }

  public val citizenship_label_caps: StringResource by 
      lazy { init_citizenship_label_caps() }

  public val city_label: StringResource by 
      lazy { init_city_label() }

  public val city_label_short: StringResource by 
      lazy { init_city_label_short() }

  public val city_row: StringResource by 
      lazy { init_city_row() }

  public val city_zone_label: StringResource by 
      lazy { init_city_zone_label() }

  public val city_zone_placeholder: StringResource by 
      lazy { init_city_zone_placeholder() }

  public val clear_all_caps: StringResource by 
      lazy { init_clear_all_caps() }

  public val close_button: StringResource by 
      lazy { init_close_button() }

  public val configure_shift_range: StringResource by 
      lazy { init_configure_shift_range() }

  public val confirm_acceptance: StringResource by 
      lazy { init_confirm_acceptance() }

  public val confirm_action: StringResource by 
      lazy { init_confirm_action() }

  public val confirm_all_availabilities: StringResource by 
      lazy { init_confirm_all_availabilities() }

  public val confirm_caps: StringResource by 
      lazy { init_confirm_caps() }

  public val confirm_notice_final: StringResource by 
      lazy { init_confirm_notice_final() }

  public val confirm_now_button: StringResource by 
      lazy { init_confirm_now_button() }

  public val confirm_operation: StringResource by 
      lazy { init_confirm_operation() }

  public val contact_body: StringResource by 
      lazy { init_contact_body() }

  public val contact_subject: StringResource by 
      lazy { init_contact_subject() }

  public val contacts: StringResource by 
      lazy { init_contacts() }

  public val counterparty_accepted: StringResource by 
      lazy { init_counterparty_accepted() }

  public val data_festive_label: StringResource by 
      lazy { init_data_festive_label() }

  public val date_label_header: StringResource by 
      lazy { init_date_label_header() }

  public val degree_label_caps: StringResource by 
      lazy { init_degree_label_caps() }

  public val delete_ads_confirm_msg: StringResource by 
      lazy { init_delete_ads_confirm_msg() }

  public val delete_ads_title: StringResource by 
      lazy { init_delete_ads_title() }

  public val delete_button_caps: StringResource by 
      lazy { init_delete_button_caps() }

  public val delete_label: StringResource by 
      lazy { init_delete_label() }

  public val delete_notification_msg: StringResource by 
      lazy { init_delete_notification_msg() }

  public val delete_notification_title: StringResource by 
      lazy { init_delete_notification_title() }

  public val delete_selected: StringResource by 
      lazy { init_delete_selected() }

  public val description: StringResource by 
      lazy { init_description() }

  public val digital_signature: StringResource by 
      lazy { init_digital_signature() }

  public val director_registration_label: StringResource by 
      lazy { init_director_registration_label() }

  public val discount_active_badge: StringResource by 
      lazy { init_discount_active_badge() }

  public val discount_progress_label: StringResource by 
      lazy { init_discount_progress_label() }

  public val disdici_button: StringResource by 
      lazy { init_disdici_button() }

  public val edit_ad_title: StringResource by 
      lazy { init_edit_ad_title() }

  public val edit_data_pharmacy: StringResource by 
      lazy { init_edit_data_pharmacy() }

  public val edit_data_professional: StringResource by 
      lazy { init_edit_data_professional() }

  public val edit_label: StringResource by 
      lazy { init_edit_label() }

  public val edit_profile: StringResource by 
      lazy { init_edit_profile() }

  public val email_button: StringResource by 
      lazy { init_email_button() }

  public val email_label: StringResource by 
      lazy { init_email_label() }

  public val email_placeholder: StringResource by 
      lazy { init_email_placeholder() }

  public val email_row: StringResource by 
      lazy { init_email_row() }

  public val emergency_accepted_notice: StringResource by 
      lazy { init_emergency_accepted_notice() }

  public val emergency_cancel_blocked_label: StringResource by 
      lazy { init_emergency_cancel_blocked_label() }

  public val emergency_cancel_blocked_msg: StringResource by 
      lazy { init_emergency_cancel_blocked_msg() }

  public val emergency_click_for_details: StringResource by 
      lazy { init_emergency_click_for_details() }

  public val emergency_confirm_now: StringResource by 
      lazy { init_emergency_confirm_now() }

  public val emergency_counterparty_accepted: StringResource by 
      lazy { init_emergency_counterparty_accepted() }

  public val emergency_immediate_matching: StringResource by 
      lazy { init_emergency_immediate_matching() }

  public val emergency_label: StringResource by 
      lazy { init_emergency_label() }

  public val emergency_urgent_request: StringResource by 
      lazy { init_emergency_urgent_request() }

  public val end_label: StringResource by 
      lazy { init_end_label() }

  public val error_or_duplicates: StringResource by 
      lazy { init_error_or_duplicates() }

  public val error_sending: StringResource by 
      lazy { init_error_sending() }

  public val exit_app_confirm: StringResource by 
      lazy { init_exit_app_confirm() }

  public val exit_app_title: StringResource by 
      lazy { init_exit_app_title() }

  public val farmacia: StringResource by 
      lazy { init_farmacia() }

  public val farmacista: StringResource by 
      lazy { init_farmacista() }

  public val female_gender: StringResource by 
      lazy { init_female_gender() }

  public val festive_notice_banner: StringResource by 
      lazy { init_festive_notice_banner() }

  public val filter_label: StringResource by 
      lazy { init_filter_label() }

  public val filter_show_only: StringResource by 
      lazy { init_filter_show_only() }

  public val final_confirmation: StringResource by 
      lazy { init_final_confirmation() }

  public val final_logout: StringResource by 
      lazy { init_final_logout() }

  public val friday: StringResource by 
      lazy { init_friday() }

  public val from_label: StringResource by 
      lazy { init_from_label() }

  public val gender_label: StringResource by 
      lazy { init_gender_label() }

  public val gender_label_caps: StringResource by 
      lazy { init_gender_label_caps() }

  public val generate_shifts_caps: StringResource by 
      lazy { init_generate_shifts_caps() }

  public val go_to_login: StringResource by 
      lazy { init_go_to_login() }

  public val got_it: StringResource by 
      lazy { init_got_it() }

  public val home_stats_accepted: StringResource by 
      lazy { init_home_stats_accepted() }

  public val home_stats_confirmed: StringResource by 
      lazy { init_home_stats_confirmed() }

  public val home_stats_proposed: StringResource by 
      lazy { init_home_stats_proposed() }

  public val home_stats_to_confirm: StringResource by 
      lazy { init_home_stats_to_confirm() }

  public val hourly_rate_label: StringResource by 
      lazy { init_hourly_rate_label() }

  public val how_can_we_help: StringResource by 
      lazy { init_how_can_we_help() }

  public val identity_header: StringResource by 
      lazy { init_identity_header() }

  public val in_evaluation: StringResource by 
      lazy { init_in_evaluation() }

  public val include_only_label: StringResource by 
      lazy { init_include_only_label() }

  public val inconsistent_data: StringResource by 
      lazy { init_inconsistent_data() }

  public val interval_caps: StringResource by 
      lazy { init_interval_caps() }

  public val invalid_email: StringResource by 
      lazy { init_invalid_email() }

  public val language_chinese: StringResource by 
      lazy { init_language_chinese() }

  public val language_english: StringResource by 
      lazy { init_language_english() }

  public val language_french: StringResource by 
      lazy { init_language_french() }

  public val language_german: StringResource by 
      lazy { init_language_german() }

  public val language_greek: StringResource by 
      lazy { init_language_greek() }

  public val language_italian: StringResource by 
      lazy { init_language_italian() }

  public val language_portuguese: StringResource by 
      lazy { init_language_portuguese() }

  public val language_selector: StringResource by 
      lazy { init_language_selector() }

  public val language_spanish: StringResource by 
      lazy { init_language_spanish() }

  public val loading: StringResource by 
      lazy { init_loading() }

  public val location_contacts: StringResource by 
      lazy { init_location_contacts() }

  public val login_button: StringResource by 
      lazy { init_login_button() }

  public val login_subtitle: StringResource by 
      lazy { init_login_subtitle() }

  public val login_title: StringResource by 
      lazy { init_login_title() }

  public val male_gender: StringResource by 
      lazy { init_male_gender() }

  public val manage_availability_title: StringResource by 
      lazy { init_manage_availability_title() }

  public val mandatory_fields_notice: StringResource by 
      lazy { init_mandatory_fields_notice() }

  public val matching_title: StringResource by 
      lazy { init_matching_title() }

  public val monday: StringResource by 
      lazy { init_monday() }

  public val my_favorites: StringResource by 
      lazy { init_my_favorites() }

  public val my_favorites_title: StringResource by 
      lazy { init_my_favorites_title() }

  public val name_label: StringResource by 
      lazy { init_name_label() }

  public val name_label_caps: StringResource by 
      lazy { init_name_label_caps() }

  public val name_row: StringResource by 
      lazy { init_name_row() }

  public val new_total: StringResource by 
      lazy { init_new_total() }

  public val no: StringResource by 
      lazy { init_no() }

  public val no_account_button: StringResource by 
      lazy { init_no_account_button() }

  public val no_ads_inserted: StringResource by 
      lazy { init_no_ads_inserted() }

  public val no_applications_received: StringResource by 
      lazy { init_no_applications_received() }

  public val no_available_shifts: StringResource by 
      lazy { init_no_available_shifts() }

  public val no_favorites_subtitle: StringResource by 
      lazy { init_no_favorites_subtitle() }

  public val no_favorites_yet: StringResource by 
      lazy { init_no_favorites_yet() }

  public val no_matches_active: StringResource by 
      lazy { init_no_matches_active() }

  public val no_message: StringResource by 
      lazy { init_no_message() }

  public val no_new_notifications: StringResource by 
      lazy { init_no_new_notifications() }

  public val no_pharmacies_found: StringResource by 
      lazy { init_no_pharmacies_found() }

  public val no_pharmacists_found: StringResource by 
      lazy { init_no_pharmacists_found() }

  public val nominative_label: StringResource by 
      lazy { init_nominative_label() }

  public val not_specified: StringResource by 
      lazy { init_not_specified() }

  public val notifications_title: StringResource by 
      lazy { init_notifications_title() }

  public val official_profile: StringResource by 
      lazy { init_official_profile() }

  public val ok_button: StringResource by 
      lazy { init_ok_button() }

  public val operating_area_title: StringResource by 
      lazy { init_operating_area_title() }

  public val operating_cap_label_caps: StringResource by 
      lazy { init_operating_cap_label_caps() }

  public val operating_city_label_caps: StringResource by 
      lazy { init_operating_city_label_caps() }

  public val order_registration_label: StringResource by 
      lazy { init_order_registration_label() }

  public val password_label: StringResource by 
      lazy { init_password_label() }

  public val pharmacist_details_title: StringResource by 
      lazy { init_pharmacist_details_title() }

  public val pharmacist_name_label: StringResource by 
      lazy { init_pharmacist_name_label() }

  public val pharmacists_needed: StringResource by 
      lazy { init_pharmacists_needed() }

  public val pharmacy_city_label: StringResource by 
      lazy { init_pharmacy_city_label() }

  public val pharmacy_city_placeholder: StringResource by 
      lazy { init_pharmacy_city_placeholder() }

  public val pharmacy_data: StringResource by 
      lazy { init_pharmacy_data() }

  public val pharmacy_name_label: StringResource by 
      lazy { init_pharmacy_name_label() }

  public val pharmacy_name_vat_label: StringResource by 
      lazy { init_pharmacy_name_vat_label() }

  public val pharmacy_pharmacist_fallback: StringResource by 
      lazy { init_pharmacy_pharmacist_fallback() }

  public val phone_label: StringResource by 
      lazy { init_phone_label() }

  public val phone_row: StringResource by 
      lazy { init_phone_row() }

  public val processing: StringResource by 
      lazy { init_processing() }

  public val professional_data: StringResource by 
      lazy { init_professional_data() }

  public val profile_detail_title: StringResource by 
      lazy { init_profile_detail_title() }

  public val profile_pharmacy: StringResource by 
      lazy { init_profile_pharmacy() }

  public val profile_professional: StringResource by 
      lazy { init_profile_professional() }

  public val progress_title: StringResource by 
      lazy { init_progress_title() }

  public val proposer_label: StringResource by 
      lazy { init_proposer_label() }

  public val province_label: StringResource by 
      lazy { init_province_label() }

  public val province_label_caps: StringResource by 
      lazy { init_province_label_caps() }

  public val province_label_short: StringResource by 
      lazy { init_province_label_short() }

  public val publish_availability_caps: StringResource by 
      lazy { init_publish_availability_caps() }

  public val publish_entire_batch: StringResource by 
      lazy { init_publish_entire_batch() }

  public val publish_shift_request_title: StringResource by 
      lazy { init_publish_shift_request_title() }

  public val range_festive_applied: StringResource by 
      lazy { init_range_festive_applied() }

  public val range_festive_notice: StringResource by 
      lazy { init_range_festive_notice() }

  public val rate_label_header: StringResource by 
      lazy { init_rate_label_header() }

  public val rate_label_pharmacist: StringResource by 
      lazy { init_rate_label_pharmacist() }

  public val rate_label_pharmacy: StringResource by 
      lazy { init_rate_label_pharmacy() }

  public val received_from: StringResource by 
      lazy { init_received_from() }

  public val region_label: StringResource by 
      lazy { init_region_label() }

  public val region_label_caps: StringResource by 
      lazy { init_region_label_caps() }

  public val region_label_short: StringResource by 
      lazy { init_region_label_short() }

  public val register_button_caps: StringResource by 
      lazy { init_register_button_caps() }

  public val register_title_screen: StringResource by 
      lazy { init_register_title_screen() }

  public val registration_success_message: StringResource by 
      lazy { init_registration_success_message() }

  public val registration_success_title: StringResource by 
      lazy { init_registration_success_title() }

  public val reject_button: StringResource by 
      lazy { init_reject_button() }

  public val release_shift_button: StringResource by 
      lazy { init_release_shift_button() }

  public val remember_me_label: StringResource by 
      lazy { init_remember_me_label() }

  public val remove_button: StringResource by 
      lazy { init_remove_button() }

  public val remove_favorites: StringResource by 
      lazy { init_remove_favorites() }

  public val reputation_insufficient_data: StringResource by 
      lazy { init_reputation_insufficient_data() }

  public val reputation_title: StringResource by 
      lazy { init_reputation_title() }

  public val reset_filters: StringResource by 
      lazy { init_reset_filters() }

  public val saturday: StringResource by 
      lazy { init_saturday() }

  public val save_button: StringResource by 
      lazy { init_save_button() }

  public val save_changes: StringResource by 
      lazy { init_save_changes() }

  public val search_pharmacies_subtitle: StringResource by 
      lazy { init_search_pharmacies_subtitle() }

  public val search_pharmacies_title: StringResource by 
      lazy { init_search_pharmacies_title() }

  public val search_pharmacists_title: StringResource by 
      lazy { init_search_pharmacists_title() }

  public val select_at_least_one_date: StringResource by 
      lazy { init_select_at_least_one_date() }

  public val select_availability_range: StringResource by 
      lazy { init_select_availability_range() }

  public val select_button: StringResource by 
      lazy { init_select_button() }

  public val select_dates: StringResource by 
      lazy { init_select_dates() }

  public val select_language: StringResource by 
      lazy { init_select_language() }

  public val select_period_title: StringResource by 
      lazy { init_select_period_title() }

  public val select_role: StringResource by 
      lazy { init_select_role() }

  public val select_shift_range: StringResource by 
      lazy { init_select_shift_range() }

  public val selected_count_label: StringResource by 
      lazy { init_selected_count_label() }

  public val send_report_button: StringResource by 
      lazy { init_send_report_button() }

  public val sent_by: StringResource by 
      lazy { init_sent_by() }

  public val sent_by_short: StringResource by 
      lazy { init_sent_by_short() }

  public val settings_title: StringResource by 
      lazy { init_settings_title() }

  public val shifts_ready_to_publish: StringResource by 
      lazy { init_shifts_ready_to_publish() }

  public val single_date_caps: StringResource by 
      lazy { init_single_date_caps() }

  public val skills_filter_label: StringResource by 
      lazy { init_skills_filter_label() }

  public val start_label: StringResource by 
      lazy { init_start_label() }

  public val status_accepted: StringResource by 
      lazy { init_status_accepted() }

  public val status_accepted_caps: StringResource by 
      lazy { init_status_accepted_caps() }

  public val status_cancelled: StringResource by 
      lazy { init_status_cancelled() }

  public val status_confirmed: StringResource by 
      lazy { init_status_confirmed() }

  public val status_in_progress: StringResource by 
      lazy { init_status_in_progress() }

  public val status_proposed: StringResource by 
      lazy { init_status_proposed() }

  public val status_rejected: StringResource by 
      lazy { init_status_rejected() }

  public val status_waiting: StringResource by 
      lazy { init_status_waiting() }

  public val storico_title: StringResource by 
      lazy { init_storico_title() }

  public val sunday: StringResource by 
      lazy { init_sunday() }

  public val support_alternative: StringResource by 
      lazy { init_support_alternative() }

  public val support_email_body: StringResource by 
      lazy { init_support_email_body() }

  public val support_email_subject: StringResource by 
      lazy { init_support_email_subject() }

  public val support_feedback: StringResource by 
      lazy { init_support_feedback() }

  public val support_feedback_option: StringResource by 
      lazy { init_support_feedback_option() }

  public val support_intro: StringResource by 
      lazy { init_support_intro() }

  public val support_message_label: StringResource by 
      lazy { init_support_message_label() }

  public val support_message_placeholder: StringResource by 
      lazy { init_support_message_placeholder() }

  public val support_other_option: StringResource by 
      lazy { init_support_other_option() }

  public val support_report_option: StringResource by 
      lazy { init_support_report_option() }

  public val support_technical_option: StringResource by 
      lazy { init_support_technical_option() }

  public val support_title: StringResource by 
      lazy { init_support_title() }

  public val support_type_label: StringResource by 
      lazy { init_support_type_label() }

  public val surname_label: StringResource by 
      lazy { init_surname_label() }

  public val surname_label_caps: StringResource by 
      lazy { init_surname_label_caps() }

  public val surname_row: StringResource by 
      lazy { init_surname_row() }

  public val tab_ads: StringResource by 
      lazy { init_tab_ads() }

  public val tab_home: StringResource by 
      lazy { init_tab_home() }

  public val tab_profile: StringResource by 
      lazy { init_tab_profile() }

  public val tab_search: StringResource by 
      lazy { init_tab_search() }

  public val tax_code_error_invalid: StringResource by 
      lazy { init_tax_code_error_invalid() }

  public val tax_code_error_length: StringResource by 
      lazy { init_tax_code_error_length() }

  public val tax_code_label: StringResource by 
      lazy { init_tax_code_label() }

  public val tax_code_label_caps: StringResource by 
      lazy { init_tax_code_label_caps() }

  public val tax_code_row: StringResource by 
      lazy { init_tax_code_row() }

  public val thursday: StringResource by 
      lazy { init_thursday() }

  public val time_active_now: StringResource by 
      lazy { init_time_active_now() }

  public val time_label_header: StringResource by 
      lazy { init_time_label_header() }

  public val time_remaining: StringResource by 
      lazy { init_time_remaining() }

  public val total_per_shift: StringResource by 
      lazy { init_total_per_shift() }

  public val tuesday: StringResource by 
      lazy { init_tuesday() }

  public val type_min_chars: StringResource by 
      lazy { init_type_min_chars() }

  public val user_not_logged_in: StringResource by 
      lazy { init_user_not_logged_in() }

  public val vat_label_caps: StringResource by 
      lazy { init_vat_label_caps() }

  public val vat_number: StringResource by 
      lazy { init_vat_number() }

  public val view_in_calendar: StringResource by 
      lazy { init_view_in_calendar() }

  public val waiting_counterparty: StringResource by 
      lazy { init_waiting_counterparty() }

  public val waiting_final_confirmation: StringResource by 
      lazy { init_waiting_final_confirmation() }

  public val wednesday: StringResource by 
      lazy { init_wednesday() }

  public val welcome: StringResource by 
      lazy { init_welcome() }

  public val welcome_back: StringResource by 
      lazy { init_welcome_back() }

  public val yes: StringResource by 
      lazy { init_yes() }

  public val yes_cancel: StringResource by 
      lazy { init_yes_cancel() }

  public val your_active_ads: StringResource by 
      lazy { init_your_active_ads() }

  public val your_proposal: StringResource by 
      lazy { init_your_proposal() }

  public val zone_label_header: StringResource by 
      lazy { init_zone_label_header() }
}

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("accept_button", CommonMainString0.accept_button)
  map.put("accept_confirm_notice", CommonMainString0.accept_confirm_notice)
  map.put("accept_no_cancel_notice", CommonMainString0.accept_no_cancel_notice)
  map.put("ad_update_error", CommonMainString0.ad_update_error)
  map.put("ad_updated_success", CommonMainString0.ad_updated_success)
  map.put("add_date_caps", CommonMainString0.add_date_caps)
  map.put("add_favorites", CommonMainString0.add_favorites)
  map.put("add_to_batch", CommonMainString0.add_to_batch)
  map.put("address_label", CommonMainString0.address_label)
  map.put("address_label_caps", CommonMainString0.address_label_caps)
  map.put("address_row", CommonMainString0.address_row)
  map.put("ads_deleted", CommonMainString0.ads_deleted)
  map.put("all_filter", CommonMainString0.all_filter)
  map.put("already_have_account_button", CommonMainString0.already_have_account_button)
  map.put("any_period", CommonMainString0.any_period)
  map.put("app_name", CommonMainString0.app_name)
  map.put("apply_button", CommonMainString0.apply_button)
  map.put("at_hours", CommonMainString0.at_hours)
  map.put("attention", CommonMainString0.attention)
  map.put("availabilities_saved", CommonMainString0.availabilities_saved)
  map.put("availabilities_to_save", CommonMainString0.availabilities_to_save)
  map.put("available_shifts", CommonMainString0.available_shifts)
  map.put("back_nav", CommonMainString0.back_nav)
  map.put("batch_availability_mgmt", CommonMainString0.batch_availability_mgmt)
  map.put("batch_publish_mgmt", CommonMainString0.batch_publish_mgmt)
  map.put("batch_published_success", CommonMainString0.batch_published_success)
  map.put("birth_date_label", CommonMainString0.birth_date_label)
  map.put("birth_place_label", CommonMainString0.birth_place_label)
  map.put("born_at", CommonMainString0.born_at)
  map.put("born_on", CommonMainString0.born_on)
  map.put("call_button", CommonMainString0.call_button)
  map.put("cancel_button", CommonMainString0.cancel_button)
  map.put("cancel_match_button", CommonMainString0.cancel_match_button)
  map.put("cancel_match_confirm_msg", CommonMainString0.cancel_match_confirm_msg)
  map.put("cap_label", CommonMainString0.cap_label)
  map.put("cap_label_short", CommonMainString0.cap_label_short)
  map.put("citizenship_label", CommonMainString0.citizenship_label)
  map.put("citizenship_label_caps", CommonMainString0.citizenship_label_caps)
  map.put("city_label", CommonMainString0.city_label)
  map.put("city_label_short", CommonMainString0.city_label_short)
  map.put("city_row", CommonMainString0.city_row)
  map.put("city_zone_label", CommonMainString0.city_zone_label)
  map.put("city_zone_placeholder", CommonMainString0.city_zone_placeholder)
  map.put("clear_all_caps", CommonMainString0.clear_all_caps)
  map.put("close_button", CommonMainString0.close_button)
  map.put("configure_shift_range", CommonMainString0.configure_shift_range)
  map.put("confirm_acceptance", CommonMainString0.confirm_acceptance)
  map.put("confirm_action", CommonMainString0.confirm_action)
  map.put("confirm_all_availabilities", CommonMainString0.confirm_all_availabilities)
  map.put("confirm_caps", CommonMainString0.confirm_caps)
  map.put("confirm_notice_final", CommonMainString0.confirm_notice_final)
  map.put("confirm_now_button", CommonMainString0.confirm_now_button)
  map.put("confirm_operation", CommonMainString0.confirm_operation)
  map.put("contact_body", CommonMainString0.contact_body)
  map.put("contact_subject", CommonMainString0.contact_subject)
  map.put("contacts", CommonMainString0.contacts)
  map.put("counterparty_accepted", CommonMainString0.counterparty_accepted)
  map.put("data_festive_label", CommonMainString0.data_festive_label)
  map.put("date_label_header", CommonMainString0.date_label_header)
  map.put("degree_label_caps", CommonMainString0.degree_label_caps)
  map.put("delete_ads_confirm_msg", CommonMainString0.delete_ads_confirm_msg)
  map.put("delete_ads_title", CommonMainString0.delete_ads_title)
  map.put("delete_button_caps", CommonMainString0.delete_button_caps)
  map.put("delete_label", CommonMainString0.delete_label)
  map.put("delete_notification_msg", CommonMainString0.delete_notification_msg)
  map.put("delete_notification_title", CommonMainString0.delete_notification_title)
  map.put("delete_selected", CommonMainString0.delete_selected)
  map.put("description", CommonMainString0.description)
  map.put("digital_signature", CommonMainString0.digital_signature)
  map.put("director_registration_label", CommonMainString0.director_registration_label)
  map.put("discount_active_badge", CommonMainString0.discount_active_badge)
  map.put("discount_progress_label", CommonMainString0.discount_progress_label)
  map.put("disdici_button", CommonMainString0.disdici_button)
  map.put("edit_ad_title", CommonMainString0.edit_ad_title)
  map.put("edit_data_pharmacy", CommonMainString0.edit_data_pharmacy)
  map.put("edit_data_professional", CommonMainString0.edit_data_professional)
  map.put("edit_label", CommonMainString0.edit_label)
  map.put("edit_profile", CommonMainString0.edit_profile)
  map.put("email_button", CommonMainString0.email_button)
  map.put("email_label", CommonMainString0.email_label)
  map.put("email_placeholder", CommonMainString0.email_placeholder)
  map.put("email_row", CommonMainString0.email_row)
  map.put("emergency_accepted_notice", CommonMainString0.emergency_accepted_notice)
  map.put("emergency_cancel_blocked_label", CommonMainString0.emergency_cancel_blocked_label)
  map.put("emergency_cancel_blocked_msg", CommonMainString0.emergency_cancel_blocked_msg)
  map.put("emergency_click_for_details", CommonMainString0.emergency_click_for_details)
  map.put("emergency_confirm_now", CommonMainString0.emergency_confirm_now)
  map.put("emergency_counterparty_accepted", CommonMainString0.emergency_counterparty_accepted)
  map.put("emergency_immediate_matching", CommonMainString0.emergency_immediate_matching)
  map.put("emergency_label", CommonMainString0.emergency_label)
  map.put("emergency_urgent_request", CommonMainString0.emergency_urgent_request)
  map.put("end_label", CommonMainString0.end_label)
  map.put("error_or_duplicates", CommonMainString0.error_or_duplicates)
  map.put("error_sending", CommonMainString0.error_sending)
  map.put("exit_app_confirm", CommonMainString0.exit_app_confirm)
  map.put("exit_app_title", CommonMainString0.exit_app_title)
  map.put("farmacia", CommonMainString0.farmacia)
  map.put("farmacista", CommonMainString0.farmacista)
  map.put("female_gender", CommonMainString0.female_gender)
  map.put("festive_notice_banner", CommonMainString0.festive_notice_banner)
  map.put("filter_label", CommonMainString0.filter_label)
  map.put("filter_show_only", CommonMainString0.filter_show_only)
  map.put("final_confirmation", CommonMainString0.final_confirmation)
  map.put("final_logout", CommonMainString0.final_logout)
  map.put("friday", CommonMainString0.friday)
  map.put("from_label", CommonMainString0.from_label)
  map.put("gender_label", CommonMainString0.gender_label)
  map.put("gender_label_caps", CommonMainString0.gender_label_caps)
  map.put("generate_shifts_caps", CommonMainString0.generate_shifts_caps)
  map.put("go_to_login", CommonMainString0.go_to_login)
  map.put("got_it", CommonMainString0.got_it)
  map.put("home_stats_accepted", CommonMainString0.home_stats_accepted)
  map.put("home_stats_confirmed", CommonMainString0.home_stats_confirmed)
  map.put("home_stats_proposed", CommonMainString0.home_stats_proposed)
  map.put("home_stats_to_confirm", CommonMainString0.home_stats_to_confirm)
  map.put("hourly_rate_label", CommonMainString0.hourly_rate_label)
  map.put("how_can_we_help", CommonMainString0.how_can_we_help)
  map.put("identity_header", CommonMainString0.identity_header)
  map.put("in_evaluation", CommonMainString0.in_evaluation)
  map.put("include_only_label", CommonMainString0.include_only_label)
  map.put("inconsistent_data", CommonMainString0.inconsistent_data)
  map.put("interval_caps", CommonMainString0.interval_caps)
  map.put("invalid_email", CommonMainString0.invalid_email)
  map.put("language_chinese", CommonMainString0.language_chinese)
  map.put("language_english", CommonMainString0.language_english)
  map.put("language_french", CommonMainString0.language_french)
  map.put("language_german", CommonMainString0.language_german)
  map.put("language_greek", CommonMainString0.language_greek)
  map.put("language_italian", CommonMainString0.language_italian)
  map.put("language_portuguese", CommonMainString0.language_portuguese)
  map.put("language_selector", CommonMainString0.language_selector)
  map.put("language_spanish", CommonMainString0.language_spanish)
  map.put("loading", CommonMainString0.loading)
  map.put("location_contacts", CommonMainString0.location_contacts)
  map.put("login_button", CommonMainString0.login_button)
  map.put("login_subtitle", CommonMainString0.login_subtitle)
  map.put("login_title", CommonMainString0.login_title)
  map.put("male_gender", CommonMainString0.male_gender)
  map.put("manage_availability_title", CommonMainString0.manage_availability_title)
  map.put("mandatory_fields_notice", CommonMainString0.mandatory_fields_notice)
  map.put("matching_title", CommonMainString0.matching_title)
  map.put("monday", CommonMainString0.monday)
  map.put("my_favorites", CommonMainString0.my_favorites)
  map.put("my_favorites_title", CommonMainString0.my_favorites_title)
  map.put("name_label", CommonMainString0.name_label)
  map.put("name_label_caps", CommonMainString0.name_label_caps)
  map.put("name_row", CommonMainString0.name_row)
  map.put("new_total", CommonMainString0.new_total)
  map.put("no", CommonMainString0.no)
  map.put("no_account_button", CommonMainString0.no_account_button)
  map.put("no_ads_inserted", CommonMainString0.no_ads_inserted)
  map.put("no_applications_received", CommonMainString0.no_applications_received)
  map.put("no_available_shifts", CommonMainString0.no_available_shifts)
  map.put("no_favorites_subtitle", CommonMainString0.no_favorites_subtitle)
  map.put("no_favorites_yet", CommonMainString0.no_favorites_yet)
  map.put("no_matches_active", CommonMainString0.no_matches_active)
  map.put("no_message", CommonMainString0.no_message)
  map.put("no_new_notifications", CommonMainString0.no_new_notifications)
  map.put("no_pharmacies_found", CommonMainString0.no_pharmacies_found)
  map.put("no_pharmacists_found", CommonMainString0.no_pharmacists_found)
  map.put("nominative_label", CommonMainString0.nominative_label)
  map.put("not_specified", CommonMainString0.not_specified)
  map.put("notifications_title", CommonMainString0.notifications_title)
  map.put("official_profile", CommonMainString0.official_profile)
  map.put("ok_button", CommonMainString0.ok_button)
  map.put("operating_area_title", CommonMainString0.operating_area_title)
  map.put("operating_cap_label_caps", CommonMainString0.operating_cap_label_caps)
  map.put("operating_city_label_caps", CommonMainString0.operating_city_label_caps)
  map.put("order_registration_label", CommonMainString0.order_registration_label)
  map.put("password_label", CommonMainString0.password_label)
  map.put("pharmacist_details_title", CommonMainString0.pharmacist_details_title)
  map.put("pharmacist_name_label", CommonMainString0.pharmacist_name_label)
  map.put("pharmacists_needed", CommonMainString0.pharmacists_needed)
  map.put("pharmacy_city_label", CommonMainString0.pharmacy_city_label)
  map.put("pharmacy_city_placeholder", CommonMainString0.pharmacy_city_placeholder)
  map.put("pharmacy_data", CommonMainString0.pharmacy_data)
  map.put("pharmacy_name_label", CommonMainString0.pharmacy_name_label)
  map.put("pharmacy_name_vat_label", CommonMainString0.pharmacy_name_vat_label)
  map.put("pharmacy_pharmacist_fallback", CommonMainString0.pharmacy_pharmacist_fallback)
  map.put("phone_label", CommonMainString0.phone_label)
  map.put("phone_row", CommonMainString0.phone_row)
  map.put("processing", CommonMainString0.processing)
  map.put("professional_data", CommonMainString0.professional_data)
  map.put("profile_detail_title", CommonMainString0.profile_detail_title)
  map.put("profile_pharmacy", CommonMainString0.profile_pharmacy)
  map.put("profile_professional", CommonMainString0.profile_professional)
  map.put("progress_title", CommonMainString0.progress_title)
  map.put("proposer_label", CommonMainString0.proposer_label)
  map.put("province_label", CommonMainString0.province_label)
  map.put("province_label_caps", CommonMainString0.province_label_caps)
  map.put("province_label_short", CommonMainString0.province_label_short)
  map.put("publish_availability_caps", CommonMainString0.publish_availability_caps)
  map.put("publish_entire_batch", CommonMainString0.publish_entire_batch)
  map.put("publish_shift_request_title", CommonMainString0.publish_shift_request_title)
  map.put("range_festive_applied", CommonMainString0.range_festive_applied)
  map.put("range_festive_notice", CommonMainString0.range_festive_notice)
  map.put("rate_label_header", CommonMainString0.rate_label_header)
  map.put("rate_label_pharmacist", CommonMainString0.rate_label_pharmacist)
  map.put("rate_label_pharmacy", CommonMainString0.rate_label_pharmacy)
  map.put("received_from", CommonMainString0.received_from)
  map.put("region_label", CommonMainString0.region_label)
  map.put("region_label_caps", CommonMainString0.region_label_caps)
  map.put("region_label_short", CommonMainString0.region_label_short)
  map.put("register_button_caps", CommonMainString0.register_button_caps)
  map.put("register_title_screen", CommonMainString0.register_title_screen)
  map.put("registration_success_message", CommonMainString0.registration_success_message)
  map.put("registration_success_title", CommonMainString0.registration_success_title)
  map.put("reject_button", CommonMainString0.reject_button)
  map.put("release_shift_button", CommonMainString0.release_shift_button)
  map.put("remember_me_label", CommonMainString0.remember_me_label)
  map.put("remove_button", CommonMainString0.remove_button)
  map.put("remove_favorites", CommonMainString0.remove_favorites)
  map.put("reputation_insufficient_data", CommonMainString0.reputation_insufficient_data)
  map.put("reputation_title", CommonMainString0.reputation_title)
  map.put("reset_filters", CommonMainString0.reset_filters)
  map.put("saturday", CommonMainString0.saturday)
  map.put("save_button", CommonMainString0.save_button)
  map.put("save_changes", CommonMainString0.save_changes)
  map.put("search_pharmacies_subtitle", CommonMainString0.search_pharmacies_subtitle)
  map.put("search_pharmacies_title", CommonMainString0.search_pharmacies_title)
  map.put("search_pharmacists_title", CommonMainString0.search_pharmacists_title)
  map.put("select_at_least_one_date", CommonMainString0.select_at_least_one_date)
  map.put("select_availability_range", CommonMainString0.select_availability_range)
  map.put("select_button", CommonMainString0.select_button)
  map.put("select_dates", CommonMainString0.select_dates)
  map.put("select_language", CommonMainString0.select_language)
  map.put("select_period_title", CommonMainString0.select_period_title)
  map.put("select_role", CommonMainString0.select_role)
  map.put("select_shift_range", CommonMainString0.select_shift_range)
  map.put("selected_count_label", CommonMainString0.selected_count_label)
  map.put("send_report_button", CommonMainString0.send_report_button)
  map.put("sent_by", CommonMainString0.sent_by)
  map.put("sent_by_short", CommonMainString0.sent_by_short)
  map.put("settings_title", CommonMainString0.settings_title)
  map.put("shifts_ready_to_publish", CommonMainString0.shifts_ready_to_publish)
  map.put("single_date_caps", CommonMainString0.single_date_caps)
  map.put("skills_filter_label", CommonMainString0.skills_filter_label)
  map.put("start_label", CommonMainString0.start_label)
  map.put("status_accepted", CommonMainString0.status_accepted)
  map.put("status_accepted_caps", CommonMainString0.status_accepted_caps)
  map.put("status_cancelled", CommonMainString0.status_cancelled)
  map.put("status_confirmed", CommonMainString0.status_confirmed)
  map.put("status_in_progress", CommonMainString0.status_in_progress)
  map.put("status_proposed", CommonMainString0.status_proposed)
  map.put("status_rejected", CommonMainString0.status_rejected)
  map.put("status_waiting", CommonMainString0.status_waiting)
  map.put("storico_title", CommonMainString0.storico_title)
  map.put("sunday", CommonMainString0.sunday)
  map.put("support_alternative", CommonMainString0.support_alternative)
  map.put("support_email_body", CommonMainString0.support_email_body)
  map.put("support_email_subject", CommonMainString0.support_email_subject)
  map.put("support_feedback", CommonMainString0.support_feedback)
  map.put("support_feedback_option", CommonMainString0.support_feedback_option)
  map.put("support_intro", CommonMainString0.support_intro)
  map.put("support_message_label", CommonMainString0.support_message_label)
  map.put("support_message_placeholder", CommonMainString0.support_message_placeholder)
  map.put("support_other_option", CommonMainString0.support_other_option)
  map.put("support_report_option", CommonMainString0.support_report_option)
  map.put("support_technical_option", CommonMainString0.support_technical_option)
  map.put("support_title", CommonMainString0.support_title)
  map.put("support_type_label", CommonMainString0.support_type_label)
  map.put("surname_label", CommonMainString0.surname_label)
  map.put("surname_label_caps", CommonMainString0.surname_label_caps)
  map.put("surname_row", CommonMainString0.surname_row)
  map.put("tab_ads", CommonMainString0.tab_ads)
  map.put("tab_home", CommonMainString0.tab_home)
  map.put("tab_profile", CommonMainString0.tab_profile)
  map.put("tab_search", CommonMainString0.tab_search)
  map.put("tax_code_error_invalid", CommonMainString0.tax_code_error_invalid)
  map.put("tax_code_error_length", CommonMainString0.tax_code_error_length)
  map.put("tax_code_label", CommonMainString0.tax_code_label)
  map.put("tax_code_label_caps", CommonMainString0.tax_code_label_caps)
  map.put("tax_code_row", CommonMainString0.tax_code_row)
  map.put("thursday", CommonMainString0.thursday)
  map.put("time_active_now", CommonMainString0.time_active_now)
  map.put("time_label_header", CommonMainString0.time_label_header)
  map.put("time_remaining", CommonMainString0.time_remaining)
  map.put("total_per_shift", CommonMainString0.total_per_shift)
  map.put("tuesday", CommonMainString0.tuesday)
  map.put("type_min_chars", CommonMainString0.type_min_chars)
  map.put("user_not_logged_in", CommonMainString0.user_not_logged_in)
  map.put("vat_label_caps", CommonMainString0.vat_label_caps)
  map.put("vat_number", CommonMainString0.vat_number)
  map.put("view_in_calendar", CommonMainString0.view_in_calendar)
  map.put("waiting_counterparty", CommonMainString0.waiting_counterparty)
  map.put("waiting_final_confirmation", CommonMainString0.waiting_final_confirmation)
  map.put("wednesday", CommonMainString0.wednesday)
  map.put("welcome", CommonMainString0.welcome)
  map.put("welcome_back", CommonMainString0.welcome_back)
  map.put("yes", CommonMainString0.yes)
  map.put("yes_cancel", CommonMainString0.yes_cancel)
  map.put("your_active_ads", CommonMainString0.your_active_ads)
  map.put("your_proposal", CommonMainString0.your_proposal)
  map.put("zone_label_header", CommonMainString0.zone_label_header)
}

internal val Res.string.accept_button: StringResource
  get() = CommonMainString0.accept_button

private fun init_accept_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:accept_button", "accept_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10,
    33),
    )
)

internal val Res.string.accept_confirm_notice: StringResource
  get() = CommonMainString0.accept_confirm_notice

private fun init_accept_confirm_notice(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:accept_confirm_notice", "accept_confirm_notice",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    48, 133),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    52, 209),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    40, 109),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    44, 125),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    44, 121),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    44, 121),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    52, 197),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    40, 97),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 44,
    113),
    )
)

internal val Res.string.accept_no_cancel_notice: StringResource
  get() = CommonMainString0.accept_no_cancel_notice

private fun init_accept_no_cancel_notice(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:accept_no_cancel_notice", "accept_no_cancel_notice",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 158,
    79),
    )
)

internal val Res.string.ad_update_error: StringResource
  get() = CommonMainString0.ad_update_error

private fun init_ad_update_error(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:ad_update_error", "ad_update_error",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    182, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    262, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    150, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    170, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    166, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    166, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    250, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    138, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 238,
    59),
    )
)

internal val Res.string.ad_updated_success: StringResource
  get() = CommonMainString0.ad_updated_success

private fun init_ad_updated_success(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:ad_updated_success", "ad_updated_success",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    246, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    350, 110),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    190, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    230, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    230, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    218, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    318, 102),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    178, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 298,
    70),
    )
)

internal val Res.string.add_date_caps: StringResource
  get() = CommonMainString0.add_date_caps

private fun init_add_date_caps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:add_date_caps", "add_date_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 369,
    41),
    )
)

internal val Res.string.add_favorites: StringResource
  get() = CommonMainString0.add_favorites

private fun init_add_favorites(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:add_favorites", "add_favorites",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    317, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    461, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    249, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    301, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    289, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    289, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    421, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    233, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 411,
    49),
    )
)

internal val Res.string.add_to_batch: StringResource
  get() = CommonMainString0.add_to_batch

private fun init_add_to_batch(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:add_to_batch", "add_to_batch",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    371, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    539, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    295, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    351, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    339, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    343, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    495, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    275, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 461,
    44),
    )
)

internal val Res.string.address_label: StringResource
  get() = CommonMainString0.address_label

private fun init_address_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:address_label", "address_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    459, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    659, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    371, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    439, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    419, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    423, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    599, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    351, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 545,
    37),
    )
)

internal val Res.string.address_label_caps: StringResource
  get() = CommonMainString0.address_label_caps

private fun init_address_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:address_label_caps", "address_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    420, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    608, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    332, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    396, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    380, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    388, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    556, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    316, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 506,
    38),
    )
)

internal val Res.string.address_row: StringResource
  get() = CommonMainString0.address_row

private fun init_address_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:address_row", "address_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    493, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    709, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    405, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    477, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    453, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    457, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    637, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    385, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 583,
    31),
    )
)

internal val Res.string.ads_deleted: StringResource
  get() = CommonMainString0.ads_deleted

private fun init_ads_deleted(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:ads_deleted", "ads_deleted",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    525, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    753, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    437, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    513, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    485, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    485, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    673, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    413, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 615,
    43),
    )
)

internal val Res.string.all_filter: StringResource
  get() = CommonMainString0.all_filter

private fun init_all_filter(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:all_filter", "all_filter",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    569, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    833, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    473, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    561, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    533, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    533, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    741, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    453, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 659,
    26),
    )
)

internal val Res.string.already_have_account_button: StringResource
  get() = CommonMainString0.already_have_account_button

private fun init_already_have_account_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:already_have_account_button", "already_have_account_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    596, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    864, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    496, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    588, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    560, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    560, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    768, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    480, 63),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 686,
    71),
    )
)

internal val Res.string.any_period: StringResource
  get() = CommonMainString0.any_period

private fun init_any_period(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:any_period", "any_period",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    668, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    972, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    572, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    664, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    640, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    624, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    860, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    544, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 758,
    42),
    )
)

internal val Res.string.app_name: StringResource
  get() = CommonMainString0.app_name

private fun init_app_name(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:app_name", "app_name",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    715, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1043, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    607, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    707, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    679, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    667, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    911, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    579, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 801,
    28),
    )
)

internal val Res.string.apply_button: StringResource
  get() = CommonMainString0.apply_button

private fun init_apply_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:apply_button", "apply_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    744, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1072, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    636, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    736, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    708, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    696, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    940, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    608, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 830,
    32),
    )
)

internal val Res.string.at_hours: StringResource
  get() = CommonMainString0.at_hours

private fun init_at_hours(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:at_hours", "at_hours",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 863,
    28),
    )
)

internal val Res.string.attention: StringResource
  get() = CommonMainString0.attention

private fun init_attention(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:attention", "attention",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    777, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1117, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    665, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    769, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    741, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    729, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    985, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    637, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 892,
    33),
    )
)

internal val Res.string.availabilities_saved: StringResource
  get() = CommonMainString0.availabilities_saved

private fun init_availabilities_saved(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:availabilities_saved", "availabilities_saved",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    807, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1155, 112),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    695, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    799, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    771, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    759, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1027, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    663, 56),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 926,
    60),
    )
)

internal val Res.string.availabilities_to_save: StringResource
  get() = CommonMainString0.availabilities_to_save

private fun init_availabilities_to_save(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:availabilities_to_save", "availabilities_to_save",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    876, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1268, 110),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    752, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    868, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    844, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    824, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1112, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    720, 62),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 987,
    66),
    )
)

internal val Res.string.available_shifts: StringResource
  get() = CommonMainString0.available_shifts

private fun init_available_shifts(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:available_shifts", "available_shifts",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    951, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1379, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    815, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    939, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    919, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    891, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1211, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    783, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1054,
    48),
    )
)

internal val Res.string.back_nav: StringResource
  get() = CommonMainString0.back_nav

private fun init_back_nav(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:back_nav", "back_nav",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1004, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1452, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    864, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    988, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    968, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    944, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1276, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    824, 24),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1103,
    28),
    )
)

internal val Res.string.batch_availability_mgmt: StringResource
  get() = CommonMainString0.batch_availability_mgmt

private fun init_batch_availability_mgmt(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:batch_availability_mgmt", "batch_availability_mgmt",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1033, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1481, 127),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    889, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1013, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    993, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    969, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1309, 115),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    849, 59),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1132,
    75),
    )
)

internal val Res.string.batch_publish_mgmt: StringResource
  get() = CommonMainString0.batch_publish_mgmt

private fun init_batch_publish_mgmt(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:batch_publish_mgmt", "batch_publish_mgmt",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1109, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1609, 114),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    961, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1093, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1077, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1049, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1425, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    909, 50),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1208,
    70),
    )
)

internal val Res.string.batch_published_success: StringResource
  get() = CommonMainString0.batch_published_success

private fun init_batch_published_success(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:batch_published_success", "batch_published_success",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1168, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1724, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1024, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1164, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1144, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1120, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1504, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    960, 63),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1279,
    63),
    )
)

internal val Res.string.birth_date_label: StringResource
  get() = CommonMainString0.birth_date_label

private fun init_birth_date_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:birth_date_label", "birth_date_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1240, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1828, 104),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1088, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1236, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1196, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1188, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1596, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1024, 64),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1343,
    60),
    )
)

internal val Res.string.birth_place_label: StringResource
  get() = CommonMainString0.birth_place_label

private fun init_birth_place_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:birth_place_label", "birth_place_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1301, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1933, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1149, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1305, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1265, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1257, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1685, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1089, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1404,
    49),
    )
)

internal val Res.string.born_at: StringResource
  get() = CommonMainString0.born_at

private fun init_born_at(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:born_at", "born_at",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1343, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    1999, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1199, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1359, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1319, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1311, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1751, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1131, 19),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1454,
    19),
    )
)

internal val Res.string.born_on: StringResource
  get() = CommonMainString0.born_on

private fun init_born_on(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:born_on", "born_on",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1363, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2023, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1219, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1379, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1339, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1331, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1771, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1151, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1474,
    27),
    )
)

internal val Res.string.call_button: StringResource
  get() = CommonMainString0.call_button

private fun init_call_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:call_button", "call_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1395, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2075, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1247, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1407, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1363, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1359, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1807, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1179, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1502,
    27),
    )
)

internal val Res.string.cancel_button: StringResource
  get() = CommonMainString0.cancel_button

private fun init_cancel_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:cancel_button", "cancel_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1427, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2111, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1275, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1435, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1395, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1387, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1851, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1207, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1530,
    33),
    )
)

internal val Res.string.cancel_match_button: StringResource
  get() = CommonMainString0.cancel_match_button

private fun init_cancel_match_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:cancel_match_button", "cancel_match_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1461, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2153, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1305, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1469, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1429, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1421, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1889, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1237, 59),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1564,
    55),
    )
)

internal val Res.string.cancel_match_confirm_msg: StringResource
  get() = CommonMainString0.cancel_match_confirm_msg

private fun init_cancel_match_confirm_msg(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:cancel_match_confirm_msg", "cancel_match_confirm_msg",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1620,
    72),
    )
)

internal val Res.string.cap_label: StringResource
  get() = CommonMainString0.cap_label

private fun init_cap_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:cap_label", "cap_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1549, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2273, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1389, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1557, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1529, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1517, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2009, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1329, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1721,
    25),
    )
)

internal val Res.string.cap_label_short: StringResource
  get() = CommonMainString0.cap_label_short

private fun init_cap_label_short(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:cap_label_short", "cap_label_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1521, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2241, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1361, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1529, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1489, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1481, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1969, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1297, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1693,
    27),
    )
)

internal val Res.string.citizenship_label: StringResource
  get() = CommonMainString0.citizenship_label

private fun init_citizenship_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:citizenship_label", "citizenship_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1634, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2354, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1470, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1646, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1614, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1610, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2134, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1398, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1794,
    45),
    )
)

internal val Res.string.citizenship_label_caps: StringResource
  get() = CommonMainString0.citizenship_label_caps

private fun init_citizenship_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:citizenship_label_caps", "citizenship_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1575, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2299, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1423, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1599, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1567, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1559, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2071, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1359, 38),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1747,
    46),
    )
)

internal val Res.string.city_label: StringResource
  get() = CommonMainString0.city_label

private fun init_city_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:city_label", "city_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1725, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2449, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1549, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1729, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1693, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1693, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2233, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1469, 30),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1873,
    30),
    )
)

internal val Res.string.city_label_short: StringResource
  get() = CommonMainString0.city_label_short

private fun init_city_label_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:city_label_short", "city_label_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1692, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2408, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1516, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1692, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1660, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1656, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2192, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1436, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1840,
    32),
    )
)

internal val Res.string.city_row: StringResource
  get() = CommonMainString0.city_row

private fun init_city_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:city_row", "city_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1756, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2484, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1576, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1760, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1724, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1724, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2268, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1500, 24),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1904,
    24),
    )
)

internal val Res.string.city_zone_label: StringResource
  get() = CommonMainString0.city_zone_label

private fun init_city_zone_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:city_zone_label", "city_zone_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1781, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2513, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1601, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1785, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1749, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1749, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2301, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1525, 63),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 1929,
    79),
    )
)

internal val Res.string.city_zone_placeholder: StringResource
  get() = CommonMainString0.city_zone_placeholder

private fun init_city_zone_placeholder(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:city_zone_placeholder", "city_zone_placeholder",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1837, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2621, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1669, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1861, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1805, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1825, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2409, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1589, 61),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2009,
    73),
    )
)

internal val Res.string.clear_all_caps: StringResource
  get() = CommonMainString0.clear_all_caps

private fun init_clear_all_caps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:clear_all_caps", "clear_all_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2083,
    42),
    )
)

internal val Res.string.close_button: StringResource
  get() = CommonMainString0.close_button

private fun init_close_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:close_button", "close_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1883, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2723, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1735, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1931, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1847, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1895, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2511, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1651, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2126,
    28),
    )
)

internal val Res.string.configure_shift_range: StringResource
  get() = CommonMainString0.configure_shift_range

private fun init_configure_shift_range(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:configure_shift_range", "configure_shift_range",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1920, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2768, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1764, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1960, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1876, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1924, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2552, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1680, 57),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2155,
    57),
    )
)

internal val Res.string.confirm_acceptance: StringResource
  get() = CommonMainString0.confirm_acceptance

private fun init_confirm_acceptance(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:confirm_acceptance", "confirm_acceptance",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1990, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2854, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1822, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2022, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1938, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1986, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2646, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1738, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2213,
    54),
    )
)

internal val Res.string.confirm_action: StringResource
  get() = CommonMainString0.confirm_action

private fun init_confirm_action(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:confirm_action", "confirm_action",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2045, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2933, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1873, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2077, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1993, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2041, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2725, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1781, 30),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2268,
    34),
    )
)

internal val Res.string.confirm_all_availabilities: StringResource
  get() = CommonMainString0.confirm_all_availabilities

private fun init_confirm_all_availabilities(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:confirm_all_availabilities", "confirm_all_availabilities",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2084, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    2988, 134),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1908, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2112, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2028, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2076, 90),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2780, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1812, 74),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2303,
    86),
    )
)

internal val Res.string.confirm_caps: StringResource
  get() = CommonMainString0.confirm_caps

private fun init_confirm_caps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:confirm_caps", "confirm_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2151, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    3123, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    1987, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2179, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2091, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2167, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2863, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1887, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2390,
    32),
    )
)

internal val Res.string.confirm_notice_final: StringResource
  get() = CommonMainString0.confirm_notice_final

private fun init_confirm_notice_final(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:confirm_notice_final", "confirm_notice_final",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2188, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    3176, 316),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2020, 148),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2212, 168),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2124, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2200, 180),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2916, 272),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1916, 144),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2423,
    160),
    )
)

internal val Res.string.confirm_now_button: StringResource
  get() = CommonMainString0.confirm_now_button

private fun init_confirm_now_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:confirm_now_button", "confirm_now_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2584,
    42),
    )
)

internal val Res.string.confirm_operation: StringResource
  get() = CommonMainString0.confirm_operation

private fun init_confirm_operation(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:confirm_operation", "confirm_operation",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2627,
    53),
    )
)

internal val Res.string.contact_body: StringResource
  get() = CommonMainString0.contact_body

private fun init_contact_body(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:contact_body", "contact_body",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2273, 136),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    3493, 224),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2169, 120),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2381, 136),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2213, 132),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2381, 132),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3189, 224),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2061, 112),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2681,
    120),
    )
)

internal val Res.string.contact_subject: StringResource
  get() = CommonMainString0.contact_subject

private fun init_contact_subject(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:contact_subject", "contact_subject",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2410, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    3718, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2290, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2518, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2346, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2514, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3414, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2174, 59),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2802,
    51),
    )
)

internal val Res.string.contacts: StringResource
  get() = CommonMainString0.contacts

private fun init_contacts(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:contacts", "contacts",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2462, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    3798, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2342, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2574, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2398, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2566, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3478, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2234, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2854,
    28),
    )
)

internal val Res.string.counterparty_accepted: StringResource
  get() = CommonMainString0.counterparty_accepted

private fun init_counterparty_accepted(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:counterparty_accepted", "counterparty_accepted",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2491, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    3831, 213),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2371, 97),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2603, 121),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2427, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2595, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3519, 169),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2267, 85),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2883,
    109),
    )
)

internal val Res.string.data_festive_label: StringResource
  get() = CommonMainString0.data_festive_label

private fun init_data_festive_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:data_festive_label", "data_festive_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 2993,
    58),
    )
)

internal val Res.string.date_label_header: StringResource
  get() = CommonMainString0.date_label_header

private fun init_date_label_header(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:date_label_header", "date_label_header",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2561, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4045, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2469, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2725, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2497, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2701, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3689, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2353, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3052,
    33),
    )
)

internal val Res.string.degree_label_caps: StringResource
  get() = CommonMainString0.degree_label_caps

private fun init_degree_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:degree_label_caps", "degree_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2595, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4099, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2503, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2759, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2531, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2735, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3727, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2387, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3086,
    45),
    )
)

internal val Res.string.delete_ads_confirm_msg: StringResource
  get() = CommonMainString0.delete_ads_confirm_msg

private fun init_delete_ads_confirm_msg(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:delete_ads_confirm_msg", "delete_ads_confirm_msg",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3132,
    154),
    )
)

internal val Res.string.delete_ads_title: StringResource
  get() = CommonMainString0.delete_ads_title

private fun init_delete_ads_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:delete_ads_title", "delete_ads_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3287,
    44),
    )
)

internal val Res.string.delete_button_caps: StringResource
  get() = CommonMainString0.delete_button_caps

private fun init_delete_button_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:delete_button_caps", "delete_button_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3332,
    38),
    )
)

internal val Res.string.delete_label: StringResource
  get() = CommonMainString0.delete_label

private fun init_delete_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:delete_label", "delete_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3371,
    32),
    )
)

internal val Res.string.delete_notification_msg: StringResource
  get() = CommonMainString0.delete_notification_msg

private fun init_delete_notification_msg(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:delete_notification_msg", "delete_notification_msg",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3404,
    83),
    )
)

internal val Res.string.delete_notification_title: StringResource
  get() = CommonMainString0.delete_notification_title

private fun init_delete_notification_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:delete_notification_title", "delete_notification_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3488,
    57),
    )
)

internal val Res.string.delete_selected: StringResource
  get() = CommonMainString0.delete_selected

private fun init_delete_selected(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:delete_selected", "delete_selected",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2633, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4145, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2537, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2797, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2569, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2781, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3785, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2421, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3546,
    59),
    )
)

internal val Res.string.description: StringResource
  get() = CommonMainString0.description

private fun init_description(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:description", "description",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2697, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4233, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2593, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2861, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2629, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2845, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3865, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2473, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3606,
    35),
    )
)

internal val Res.string.digital_signature: StringResource
  get() = CommonMainString0.digital_signature

private fun init_digital_signature(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:digital_signature", "digital_signature",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2733, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4277, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2629, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2897, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2665, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2881, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3909, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2501, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3642,
    45),
    )
)

internal val Res.string.director_registration_label: StringResource
  get() = CommonMainString0.director_registration_label

private fun init_director_registration_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:director_registration_label", "director_registration_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2679, 67),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3688,
    79),
    )
)

internal val Res.string.discount_active_badge: StringResource
  get() = CommonMainString0.discount_active_badge

private fun init_discount_active_badge(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:discount_active_badge", "discount_active_badge",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2783, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4347, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2747, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2943, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2719, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2931, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3979, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2543, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3768,
    53),
    )
)

internal val Res.string.discount_progress_label: StringResource
  get() = CommonMainString0.discount_progress_label

private fun init_discount_progress_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:discount_progress_label", "discount_progress_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2833, 123),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4417, 175),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2801, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3001, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2773, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2985, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4049, 171),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2597, 99),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3822,
    103),
    )
)

internal val Res.string.disdici_button: StringResource
  get() = CommonMainString0.disdici_button

private fun init_disdici_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:disdici_button", "disdici_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3926,
    34),
    )
)

internal val Res.string.edit_ad_title: StringResource
  get() = CommonMainString0.edit_ad_title

private fun init_edit_ad_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:edit_ad_title", "edit_ad_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2957, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4593, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2905, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3109, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2881, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3089, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4221, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2697, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 3961,
    45),
    )
)

internal val Res.string.edit_data_pharmacy: StringResource
  get() = CommonMainString0.edit_data_pharmacy

private fun init_edit_data_pharmacy(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:edit_data_pharmacy", "edit_data_pharmacy",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3003, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4667, 110),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2939, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3151, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2927, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3131, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4307, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2735, 50),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4007,
    58),
    )
)

internal val Res.string.edit_data_professional: StringResource
  get() = CommonMainString0.edit_data_professional

private fun init_edit_data_professional(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:edit_data_professional", "edit_data_professional",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3066, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4778, 114),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    2990, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3206, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2990, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3190, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4390, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2786, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4066,
    62),
    )
)

internal val Res.string.edit_label: StringResource
  get() = CommonMainString0.edit_label

private fun init_edit_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:edit_label", "edit_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4129,
    30),
    )
)

internal val Res.string.edit_profile: StringResource
  get() = CommonMainString0.edit_profile

private fun init_edit_profile(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:edit_profile", "edit_profile",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3125, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4893, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3045, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3269, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3061, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3249, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4477, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2841, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4160,
    44),
    )
)

internal val Res.string.email_button: StringResource
  get() = CommonMainString0.email_button

private fun init_email_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:email_button", "email_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3170, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4962, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3082, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3310, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3106, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3290, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4554, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2886, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4205,
    28),
    )
)

internal val Res.string.email_label: StringResource
  get() = CommonMainString0.email_label

private fun init_email_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:email_label", "email_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3199, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    4991, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3111, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3339, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3135, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3319, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4583, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2923, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4234,
    27),
    )
)

internal val Res.string.email_placeholder: StringResource
  get() = CommonMainString0.email_placeholder

private fun init_email_placeholder(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:email_placeholder", "email_placeholder",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3227, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5019, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3139, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3387, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3163, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3347, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4647, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2959, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4262,
    45),
    )
)

internal val Res.string.email_row: StringResource
  get() = CommonMainString0.email_row

private fun init_email_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:email_row", "email_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3277, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5085, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3189, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3433, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3209, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3397, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4693, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3009, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4308,
    25),
    )
)

internal val Res.string.emergency_accepted_notice: StringResource
  get() = CommonMainString0.emergency_accepted_notice

private fun init_emergency_accepted_notice(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_accepted_notice", "emergency_accepted_notice",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4334,
    157),
    )
)

internal val Res.string.emergency_cancel_blocked_label: StringResource
  get() = CommonMainString0.emergency_cancel_blocked_label

private fun init_emergency_cancel_blocked_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_cancel_blocked_label", "emergency_cancel_blocked_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4492,
    62),
    )
)

internal val Res.string.emergency_cancel_blocked_msg: StringResource
  get() = CommonMainString0.emergency_cancel_blocked_msg

private fun init_emergency_cancel_blocked_msg(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_cancel_blocked_msg", "emergency_cancel_blocked_msg",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4555,
    244),
    )
)

internal val Res.string.emergency_click_for_details: StringResource
  get() = CommonMainString0.emergency_click_for_details

private fun init_emergency_click_for_details(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_click_for_details", "emergency_click_for_details",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4800,
    75),
    )
)

internal val Res.string.emergency_confirm_now: StringResource
  get() = CommonMainString0.emergency_confirm_now

private fun init_emergency_confirm_now(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_confirm_now", "emergency_confirm_now",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4876,
    53),
    )
)

internal val Res.string.emergency_counterparty_accepted: StringResource
  get() = CommonMainString0.emergency_counterparty_accepted

private fun init_emergency_counterparty_accepted(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_counterparty_accepted", "emergency_counterparty_accepted",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 4930,
    91),
    )
)

internal val Res.string.emergency_immediate_matching: StringResource
  get() = CommonMainString0.emergency_immediate_matching

private fun init_emergency_immediate_matching(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_immediate_matching", "emergency_immediate_matching",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5022,
    60),
    )
)

internal val Res.string.emergency_label: StringResource
  get() = CommonMainString0.emergency_label

private fun init_emergency_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:emergency_label", "emergency_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5083,
    63),
    )
)

internal val Res.string.emergency_urgent_request: StringResource
  get() = CommonMainString0.emergency_urgent_request

private fun init_emergency_urgent_request(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:emergency_urgent_request", "emergency_urgent_request",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5147,
    56),
    )
)

internal val Res.string.end_label: StringResource
  get() = CommonMainString0.end_label

private fun init_end_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:end_label", "end_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3303, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5111, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3215, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3459, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3235, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3423, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4719, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3043, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5204,
    25),
    )
)

internal val Res.string.error_or_duplicates: StringResource
  get() = CommonMainString0.error_or_duplicates

private fun init_error_or_duplicates(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:error_or_duplicates", "error_or_duplicates",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3329, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5141, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3237, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3481, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3257, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3445, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4753, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3069, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5230,
    51),
    )
)

internal val Res.string.error_sending: StringResource
  get() = CommonMainString0.error_sending

private fun init_error_sending(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:error_sending", "error_sending",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3385, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5217, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3293, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3533, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3309, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3497, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4833, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3117, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5282,
    53),
    )
)

internal val Res.string.exit_app_confirm: StringResource
  get() = CommonMainString0.exit_app_confirm

private fun init_exit_app_confirm(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:exit_app_confirm", "exit_app_confirm",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3343, 76),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5336,
    88),
    )
)

internal val Res.string.exit_app_title: StringResource
  get() = CommonMainString0.exit_app_title

private fun init_exit_app_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:exit_app_title", "exit_app_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3420, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5425,
    42),
    )
)

internal val Res.string.farmacia: StringResource
  get() = CommonMainString0.farmacia

private fun init_farmacia(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:farmacia", "farmacia",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3431, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5299, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3455, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3587, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3363, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3547, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4903, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3159, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5468,
    28),
    )
)

internal val Res.string.farmacista: StringResource
  get() = CommonMainString0.farmacista

private fun init_farmacista(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:farmacista", "farmacista",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3460, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5340, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3484, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3616, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3392, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3576, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4936, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3188, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5497,
    34),
    )
)

internal val Res.string.female_gender: StringResource
  get() = CommonMainString0.female_gender

private fun init_female_gender(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:female_gender", "female_gender",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3491, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5391, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3519, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3655, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3427, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3615, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4979, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3215, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5532,
    25),
    )
)

internal val Res.string.festive_notice_banner: StringResource
  get() = CommonMainString0.festive_notice_banner

private fun init_festive_notice_banner(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:festive_notice_banner", "festive_notice_banner",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5558,
    101),
    )
)

internal val Res.string.filter_label: StringResource
  get() = CommonMainString0.filter_label

private fun init_filter_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:filter_label", "filter_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3545, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5660,
    28),
    )
)

internal val Res.string.filter_show_only: StringResource
  get() = CommonMainString0.filter_show_only

private fun init_filter_show_only(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:filter_show_only", "filter_show_only",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3517, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5417, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3578, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3681, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3453, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3641, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5005, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3241, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5689,
    40),
    )
)

internal val Res.string.final_confirmation: StringResource
  get() = CommonMainString0.final_confirmation

private fun init_final_confirmation(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:final_confirmation", "final_confirmation",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3562, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5478, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3619, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3726, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3506, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3686, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5070, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3282, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5730,
    54),
    )
)

internal val Res.string.final_logout: StringResource
  get() = CommonMainString0.final_logout

private fun init_final_logout(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:final_logout", "final_logout",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3621, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5557, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3670, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3785, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3565, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3745, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5169, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3325, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5785,
    44),
    )
)

internal val Res.string.friday: StringResource
  get() = CommonMainString0.friday

private fun init_friday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:friday", "friday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3666, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5630, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3707, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3826, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3614, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3790, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5234, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3362, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5830,
    26),
    )
)

internal val Res.string.from_label: StringResource
  get() = CommonMainString0.from_label

private fun init_from_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:from_label", "from_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5857,
    30),
    )
)

internal val Res.string.gender_label: StringResource
  get() = CommonMainString0.gender_label

private fun init_gender_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:gender_label", "gender_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3735, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5707, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3764, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3887, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3675, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3855, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5303, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3423, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5922,
    32),
    )
)

internal val Res.string.gender_label_caps: StringResource
  get() = CommonMainString0.gender_label_caps

private fun init_gender_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:gender_label_caps", "gender_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3693, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5669, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3730, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3853, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3641, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3821, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5269, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3389, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5888,
    33),
    )
)

internal val Res.string.generate_shifts_caps: StringResource
  get() = CommonMainString0.generate_shifts_caps

private fun init_generate_shifts_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:generate_shifts_caps", "generate_shifts_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 5955,
    44),
    )
)

internal val Res.string.go_to_login: StringResource
  get() = CommonMainString0.go_to_login

private fun init_go_to_login(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:go_to_login", "go_to_login",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3772, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5744, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3797, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3916, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3704, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3884, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5336, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3456, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6000,
    35),
    )
)

internal val Res.string.got_it: StringResource
  get() = CommonMainString0.got_it

private fun init_got_it(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:got_it", "got_it",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3804, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5816, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3833, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3952, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3744, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3924, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5396, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3492, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6036,
    42),
    )
)

internal val Res.string.home_stats_accepted: StringResource
  get() = CommonMainString0.home_stats_accepted

private fun init_home_stats_accepted(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:home_stats_accepted", "home_stats_accepted",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3855, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5883, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3876, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3995, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3787, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3967, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5455, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3535, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6079,
    39),
    )
)

internal val Res.string.home_stats_confirmed: StringResource
  get() = CommonMainString0.home_stats_confirmed

private fun init_home_stats_confirmed(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:home_stats_confirmed", "home_stats_confirmed",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3899, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    5935, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3916, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4035, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3831, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4007, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5503, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3575, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6119,
    44),
    )
)

internal val Res.string.home_stats_proposed: StringResource
  get() = CommonMainString0.home_stats_proposed

private fun init_home_stats_proposed(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:home_stats_proposed", "home_stats_proposed",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3944, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6000, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3957, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4080, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3876, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4052, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5564, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3616, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6164,
    39),
    )
)

internal val Res.string.home_stats_to_confirm: StringResource
  get() = CommonMainString0.home_stats_to_confirm

private fun init_home_stats_to_confirm(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:home_stats_to_confirm", "home_stats_to_confirm",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    3997, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6204,
    49),
    )
)

internal val Res.string.hourly_rate_label: StringResource
  get() = CommonMainString0.hourly_rate_label

private fun init_hourly_rate_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:hourly_rate_label", "hourly_rate_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3992, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6052, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4043, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4124, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3920, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4092, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5620, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3656, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6254,
    57),
    )
)

internal val Res.string.how_can_we_help: StringResource
  get() = CommonMainString0.how_can_we_help

private fun init_how_can_we_help(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:how_can_we_help", "how_can_we_help",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4046, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6126, 99),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4097, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4182, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3974, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4150, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5702, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3702, 55),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6312,
    55),
    )
)

internal val Res.string.identity_header: StringResource
  get() = CommonMainString0.identity_header

private fun init_identity_header(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:identity_header", "identity_header",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4102, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6226, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4149, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4242, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4042, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4202, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5786, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3758, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6368,
    47),
    )
)

internal val Res.string.in_evaluation: StringResource
  get() = CommonMainString0.in_evaluation

private fun init_in_evaluation(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:in_evaluation", "in_evaluation",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6416,
    45),
    )
)

internal val Res.string.include_only_label: StringResource
  get() = CommonMainString0.include_only_label

private fun init_include_only_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:include_only_label", "include_only_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6462,
    46),
    )
)

internal val Res.string.inconsistent_data: StringResource
  get() = CommonMainString0.inconsistent_data

private fun init_inconsistent_data(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:inconsistent_data", "inconsistent_data",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4154, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6274, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4197, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4290, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4090, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4250, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5834, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3802, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6509,
    45),
    )
)

internal val Res.string.interval_caps: StringResource
  get() = CommonMainString0.interval_caps

private fun init_interval_caps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:interval_caps", "interval_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6555,
    33),
    )
)

internal val Res.string.invalid_email: StringResource
  get() = CommonMainString0.invalid_email

private fun init_invalid_email(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:invalid_email", "invalid_email",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4208, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6344, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4247, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4340, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4148, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4304, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5916, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3848, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6589,
    53),
    )
)

internal val Res.string.language_chinese: StringResource
  get() = CommonMainString0.language_chinese

private fun init_language_chinese(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:language_chinese", "language_chinese",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4266, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6414, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4297, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4402, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4202, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4362, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5994, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3902, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6643,
    32),
    )
)

internal val Res.string.language_english: StringResource
  get() = CommonMainString0.language_english

private fun init_language_english(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:language_english", "language_english",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4307, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6463, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4334, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4435, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4239, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4399, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6043, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3935, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6676,
    36),
    )
)

internal val Res.string.language_french: StringResource
  get() = CommonMainString0.language_french

private fun init_language_french(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:language_french", "language_french",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4344, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6508, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4371, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4472, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4276, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4436, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6096, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3968, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6713,
    35),
    )
)

internal val Res.string.language_german: StringResource
  get() = CommonMainString0.language_german

private fun init_language_german(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:language_german", "language_german",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4384, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6552, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4403, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4508, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4312, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4472, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6152, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4000, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6749,
    35),
    )
)

internal val Res.string.language_greek: StringResource
  get() = CommonMainString0.language_greek

private fun init_language_greek(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:language_greek", "language_greek",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4420, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6600, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4435, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4544, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4348, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4508, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6200, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4032, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6785,
    30),
    )
)

internal val Res.string.language_italian: StringResource
  get() = CommonMainString0.language_italian

private fun init_language_italian(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:language_italian", "language_italian",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4459, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6647, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4466, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4575, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4379, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4539, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6247, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4067, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6816,
    36),
    )
)

internal val Res.string.language_portuguese: StringResource
  get() = CommonMainString0.language_portuguese

private fun init_language_portuguese(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:language_portuguese", "language_portuguese",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4500, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6692, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4503, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4612, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4416, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4576, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6304, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4108, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6853,
    43),
    )
)

internal val Res.string.language_selector: StringResource
  get() = CommonMainString0.language_selector

private fun init_language_selector(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:language_selector", "language_selector",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4548, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6752, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4547, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4656, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4456, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4620, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6368, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4152, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6897,
    53),
    )
)

internal val Res.string.language_spanish: StringResource
  get() = CommonMainString0.language_spanish

private fun init_language_spanish(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:language_spanish", "language_spanish",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4590, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6822, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4589, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4714, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4514, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4674, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6434, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4194, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6951,
    36),
    )
)

internal val Res.string.loading: StringResource
  get() = CommonMainString0.loading

private fun init_loading(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:loading", "loading",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4627, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6871, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4626, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4751, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4551, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4711, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6483, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4235, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 6988,
    35),
    )
)

internal val Res.string.location_contacts: StringResource
  get() = CommonMainString0.location_contacts

private fun init_location_contacts(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:location_contacts", "location_contacts",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4655, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6911, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4658, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4783, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4587, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4747, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6527, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4267, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7024,
    45),
    )
)

internal val Res.string.login_button: StringResource
  get() = CommonMainString0.login_button

private fun init_login_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:login_button", "login_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4709, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    6977, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4712, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4833, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4637, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4797, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6593, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4321, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7070,
    28),
    )
)

internal val Res.string.login_subtitle: StringResource
  get() = CommonMainString0.login_subtitle

private fun init_login_subtitle(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:login_subtitle", "login_subtitle",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4742, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7018, 118),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4741, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4866, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4674, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4826, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6630, 110),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4350, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7099,
    66),
    )
)

internal val Res.string.login_title: StringResource
  get() = CommonMainString0.login_title

private fun init_login_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:login_title", "login_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4829, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7137, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4804, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4929, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4745, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4889, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6741, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4405, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7166,
    43),
    )
)

internal val Res.string.male_gender: StringResource
  get() = CommonMainString0.male_gender

private fun init_male_gender(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:male_gender", "male_gender",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4877, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7197, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4848, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4973, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4797, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4933, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6793, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4445, 23),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7210,
    23),
    )
)

internal val Res.string.manage_availability_title: StringResource
  get() = CommonMainString0.manage_availability_title

private fun init_manage_availability_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:manage_availability_title", "manage_availability_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4901, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7221, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4872, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4997, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4821, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4957, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6817, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4469, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7234,
    65),
    )
)

internal val Res.string.mandatory_fields_notice: StringResource
  get() = CommonMainString0.mandatory_fields_notice

private fun init_mandatory_fields_notice(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mandatory_fields_notice", "mandatory_fields_notice",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4971, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7323, 167),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    4934, 99),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5063, 119),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4887, 111),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5027, 119),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6911, 171),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4523, 99),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7300,
    107),
    )
)

internal val Res.string.matching_title: StringResource
  get() = CommonMainString0.matching_title

private fun init_matching_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:matching_title", "matching_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5075, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7491, 102),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5034, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5183, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4999, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5147, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7083, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4623, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7408,
    54),
    )
)

internal val Res.string.monday: StringResource
  get() = CommonMainString0.monday

private fun init_monday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:monday", "monday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5130, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7594, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5089, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5246, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5054, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5214, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7146, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4666, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7463,
    26),
    )
)

internal val Res.string.my_favorites: StringResource
  get() = CommonMainString0.my_favorites

private fun init_my_favorites(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:my_favorites", "my_favorites",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5200, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7696, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5155, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5316, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5120, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5296, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7256, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4736, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7541,
    44),
    )
)

internal val Res.string.my_favorites_title: StringResource
  get() = CommonMainString0.my_favorites_title

private fun init_my_favorites_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:my_favorites_title", "my_favorites_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5153, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7629, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5112, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5269, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5077, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5249, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7193, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4693, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7490,
    50),
    )
)

internal val Res.string.name_label: StringResource
  get() = CommonMainString0.name_label

private fun init_name_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:name_label", "name_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5277, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7797, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5224, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5389, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5193, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5369, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7345, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4805, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7618,
    26),
    )
)

internal val Res.string.name_label_caps: StringResource
  get() = CommonMainString0.name_label_caps

private fun init_name_label_caps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:name_label_caps", "name_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5241, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7757, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5192, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5357, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5157, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5337, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7313, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4773, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7586,
    31),
    )
)

internal val Res.string.name_row: StringResource
  get() = CommonMainString0.name_row

private fun init_name_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:name_row", "name_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5308, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7832, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5259, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5416, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5224, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5396, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7372, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4832, 24),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7645,
    24),
    )
)

internal val Res.string.new_total: StringResource
  get() = CommonMainString0.new_total

private fun init_new_total(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:new_total", "new_total",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5337, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7865, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5284, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5441, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5253, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5421, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7397, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4857, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7670,
    33),
    )
)

internal val Res.string.no: StringResource
  get() = CommonMainString0.no

private fun init_no(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:no", "no",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6057, 14),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8572,
    14),
    )
)

internal val Res.string.no_account_button: StringResource
  get() = CommonMainString0.no_account_button

private fun init_no_account_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_account_button", "no_account_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5379, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    7911, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5314, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5475, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5291, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5455, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7443, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4887, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7704,
    65),
    )
)

internal val Res.string.no_ads_inserted: StringResource
  get() = CommonMainString0.no_ads_inserted

private fun init_no_ads_inserted(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:no_ads_inserted", "no_ads_inserted",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5445, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8017, 111),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5384, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5545, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5353, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5517, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7549, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4941, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7770,
    55),
    )
)

internal val Res.string.no_applications_received: StringResource
  get() = CommonMainString0.no_applications_received

private fun init_no_applications_received(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_applications_received", "no_applications_received",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5505, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8129, 148),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5428, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5609, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5409, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5573, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7641, 120),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4985, 68),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7826,
    92),
    )
)

internal val Res.string.no_available_shifts: StringResource
  get() = CommonMainString0.no_available_shifts

private fun init_no_available_shifts(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_available_shifts", "no_available_shifts",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5574, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8278, 115),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5517, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5686, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5478, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5670, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7762, 111),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5054, 63),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7919,
    67),
    )
)

internal val Res.string.no_favorites_subtitle: StringResource
  get() = CommonMainString0.no_favorites_subtitle

private fun init_no_favorites_subtitle(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_favorites_subtitle", "no_favorites_subtitle",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5646, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8394, 181),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5585, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5762, 109),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5554, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5738, 121),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7874, 173),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5118, 93),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 7987,
    97),
    )
)

internal val Res.string.no_favorites_yet: StringResource
  get() = CommonMainString0.no_favorites_yet

private fun init_no_favorites_yet(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_favorites_yet", "no_favorites_yet",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5748, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8576, 112),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5687, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5872, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5648, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5860, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8048, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5212, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8085,
    68),
    )
)

internal val Res.string.no_matches_active: StringResource
  get() = CommonMainString0.no_matches_active

private fun init_no_matches_active(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_matches_active", "no_matches_active",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5817, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8689, 125),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5760, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5937, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5701, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5925, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8145, 117),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5265, 61),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8154,
    65),
    )
)

internal val Res.string.no_message: StringResource
  get() = CommonMainString0.no_message

private fun init_no_message(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:no_message", "no_message",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5883, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8815, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5830, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6003, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5751, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6007, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8263, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5327, 30),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8220,
    42),
    )
)

internal val Res.string.no_new_notifications: StringResource
  get() = CommonMainString0.no_new_notifications

private fun init_no_new_notifications(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_new_notifications", "no_new_notifications",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8263,
    60),
    )
)

internal val Res.string.no_pharmacies_found: StringResource
  get() = CommonMainString0.no_pharmacies_found

private fun init_no_pharmacies_found(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_pharmacies_found", "no_pharmacies_found",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5922, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8870, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5865, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6038, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5790, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6050, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8318, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5358, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8324,
    59),
    )
)

internal val Res.string.no_pharmacists_found: StringResource
  get() = CommonMainString0.no_pharmacists_found

private fun init_no_pharmacists_found(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:no_pharmacists_found", "no_pharmacists_found",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5982, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    8954, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5921, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6102, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5854, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6118, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8390, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5406, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8384,
    64),
    )
)

internal val Res.string.nominative_label: StringResource
  get() = CommonMainString0.nominative_label

private fun init_nominative_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:nominative_label", "nominative_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6043, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9047, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    5978, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6175, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5915, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6191, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8467, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5459, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8449,
    40),
    )
)

internal val Res.string.not_specified: StringResource
  get() = CommonMainString0.not_specified

private fun init_not_specified(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:not_specified", "not_specified",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6096, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9108, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6015, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6220, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5956, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6224, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8500, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5492, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8490,
    41),
    )
)

internal val Res.string.notifications_title: StringResource
  get() = CommonMainString0.notifications_title

private fun init_notifications_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:notifications_title", "notifications_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8532,
    39),
    )
)

internal val Res.string.official_profile: StringResource
  get() = CommonMainString0.official_profile

private fun init_official_profile(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:official_profile", "official_profile",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6138, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9178, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6072, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6262, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5998, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6270, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8550, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5526, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8587,
    48),
    )
)

internal val Res.string.ok_button: StringResource
  get() = CommonMainString0.ok_button

private fun init_ok_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:ok_button", "ok_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6187, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9239, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6121, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6307, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6043, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6315, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8627, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5567, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8636,
    21),
    )
)

internal val Res.string.operating_area_title: StringResource
  get() = CommonMainString0.operating_area_title

private fun init_operating_area_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:operating_area_title", "operating_area_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6143, 72),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8658,
    84),
    )
)

internal val Res.string.operating_cap_label_caps: StringResource
  get() = CommonMainString0.operating_cap_label_caps

private fun init_operating_cap_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:operating_cap_label_caps", "operating_cap_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6209, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9277, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6216, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6329, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6065, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6337, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8653, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5593, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8743,
    44),
    )
)

internal val Res.string.operating_city_label_caps: StringResource
  get() = CommonMainString0.operating_city_label_caps

private fun init_operating_city_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:operating_city_label_caps", "operating_city_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6254, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9326, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6261, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6370, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6106, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6382, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8714, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5642, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8788,
    49),
    )
)

internal val Res.string.order_registration_label: StringResource
  get() = CommonMainString0.order_registration_label

private fun init_order_registration_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:order_registration_label", "order_registration_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6307, 60),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8838,
    64),
    )
)

internal val Res.string.password_label: StringResource
  get() = CommonMainString0.password_label

private fun init_password_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:password_label", "password_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6300, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9384, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6368, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6424, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6152, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6428, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8772, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5692, 30),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8903,
    34),
    )
)

internal val Res.string.pharmacist_details_title: StringResource
  get() = CommonMainString0.pharmacist_details_title

private fun init_pharmacist_details_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacist_details_title", "pharmacist_details_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6335, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9427, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6403, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6463, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6191, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6471, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8811, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5723, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8938,
    56),
    )
)

internal val Res.string.pharmacist_name_label: StringResource
  get() = CommonMainString0.pharmacist_name_label

private fun init_pharmacist_name_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacist_name_label", "pharmacist_name_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6388, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9512, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6460, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6524, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6248, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6536, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8896, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5776, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 8995,
    49),
    )
)

internal val Res.string.pharmacists_needed: StringResource
  get() = CommonMainString0.pharmacists_needed

private fun init_pharmacists_needed(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacists_needed", "pharmacists_needed",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6442, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9582, 138),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6514, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6578, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6298, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6586, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8966, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5826, 70),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9045,
    78),
    )
)

internal val Res.string.pharmacy_city_label: StringResource
  get() = CommonMainString0.pharmacy_city_label

private fun init_pharmacy_city_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacy_city_label", "pharmacy_city_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6521, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9721, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6585, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6661, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6377, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6673, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9053, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5897, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9124,
    55),
    )
)

internal val Res.string.pharmacy_city_placeholder: StringResource
  get() = CommonMainString0.pharmacy_city_placeholder

private fun init_pharmacy_city_placeholder(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacy_city_placeholder", "pharmacy_city_placeholder",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6573, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9789, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6633, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6717, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6433, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6729, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9113, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5949, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9180,
    45),
    )
)

internal val Res.string.pharmacy_data: StringResource
  get() = CommonMainString0.pharmacy_data

private fun init_pharmacy_data(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:pharmacy_data", "pharmacy_data",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6627, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9847, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6679, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6771, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6479, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6779, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9175, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6003, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9226,
    41),
    )
)

internal val Res.string.pharmacy_name_label: StringResource
  get() = CommonMainString0.pharmacy_name_label

private fun init_pharmacy_name_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacy_name_label", "pharmacy_name_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6669, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9921, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6721, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6813, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6525, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6825, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9233, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6041, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9268,
    47),
    )
)

internal val Res.string.pharmacy_name_vat_label: StringResource
  get() = CommonMainString0.pharmacy_name_vat_label

private fun init_pharmacy_name_vat_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacy_name_vat_label", "pharmacy_name_vat_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6717, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    9993, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6769, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6861, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6581, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6877, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9301, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6085, 67),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9316,
    59),
    )
)

internal val Res.string.pharmacy_pharmacist_fallback: StringResource
  get() = CommonMainString0.pharmacy_pharmacist_fallback

private fun init_pharmacy_pharmacist_fallback(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:pharmacy_pharmacist_fallback", "pharmacy_pharmacist_fallback",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9376,
    64),
    )
)

internal val Res.string.phone_label: StringResource
  get() = CommonMainString0.phone_label

private fun init_phone_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:phone_label", "phone_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6789, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10081, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6829, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6921, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6641, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6941, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9393, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6153, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9441,
    51),
    )
)

internal val Res.string.phone_row: StringResource
  get() = CommonMainString0.phone_row

private fun init_phone_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:phone_row", "phone_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6833, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10157, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6873, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6969, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6693, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6989, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9473, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6193, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9493,
    29),
    )
)

internal val Res.string.processing: StringResource
  get() = CommonMainString0.processing

private fun init_processing(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:processing", "processing",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9523,
    38),
    )
)

internal val Res.string.professional_data: StringResource
  get() = CommonMainString0.professional_data

private fun init_professional_data(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:professional_data", "professional_data",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6863, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10199, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6899, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6999, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6727, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7019, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9511, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6219, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9562,
    49),
    )
)

internal val Res.string.profile_detail_title: StringResource
  get() = CommonMainString0.profile_detail_title

private fun init_profile_detail_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_detail_title", "profile_detail_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6913, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10285, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6949, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7053, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6789, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7073, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9597, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6261, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9612,
    52),
    )
)

internal val Res.string.profile_pharmacy: StringResource
  get() = CommonMainString0.profile_pharmacy

private fun init_profile_pharmacy(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_pharmacy", "profile_pharmacy",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6962, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10366, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    6998, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7106, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6842, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7126, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9662, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6306, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9665,
    48),
    )
)

internal val Res.string.profile_professional: StringResource
  get() = CommonMainString0.profile_professional

private fun init_profile_professional(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_professional", "profile_professional",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7007, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10435, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7047, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7151, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6891, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7175, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9723, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6347, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9714,
    56),
    )
)

internal val Res.string.progress_title: StringResource
  get() = CommonMainString0.progress_title

private fun init_progress_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:progress_title", "progress_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7104, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9771,
    46),
    )
)

internal val Res.string.proposer_label: StringResource
  get() = CommonMainString0.proposer_label

private fun init_proposer_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:proposer_label", "proposer_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9818,
    46),
    )
)

internal val Res.string.province_label: StringResource
  get() = CommonMainString0.province_label

private fun init_province_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:province_label", "province_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7133, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10605, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7228, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7285, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7029, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7313, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9913, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6465, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9946,
    34),
    )
)

internal val Res.string.province_label_caps: StringResource
  get() = CommonMainString0.province_label_caps

private fun init_province_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:province_label_caps", "province_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7052, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10516, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7147, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7204, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6948, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7232, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9816, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6392, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9865,
    39),
    )
)

internal val Res.string.province_label_short: StringResource
  get() = CommonMainString0.province_label_short

private fun init_province_label_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:province_label_short", "province_label_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7092, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10560, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7187, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7244, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6988, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7272, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9864, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6428, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9905,
    40),
    )
)

internal val Res.string.publish_availability_caps: StringResource
  get() = CommonMainString0.publish_availability_caps

private fun init_publish_availability_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:publish_availability_caps", "publish_availability_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 9981,
    65),
    )
)

internal val Res.string.publish_entire_batch: StringResource
  get() = CommonMainString0.publish_entire_batch

private fun init_publish_entire_batch(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:publish_entire_batch", "publish_entire_batch",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7168, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10644, 116),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7263, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7320, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7064, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7352, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9960, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6500, 64),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10047,
    72),
    )
)

internal val Res.string.publish_shift_request_title: StringResource
  get() = CommonMainString0.publish_shift_request_title

private fun init_publish_shift_request_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:publish_shift_request_title", "publish_shift_request_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7249, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10761, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7328, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7389, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7129, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7417, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10057, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6565, 59),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10120,
    67),
    )
)

internal val Res.string.range_festive_applied: StringResource
  get() = CommonMainString0.range_festive_applied

private fun init_range_festive_applied(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:range_festive_applied", "range_festive_applied",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10188,
    93),
    )
)

internal val Res.string.range_festive_notice: StringResource
  get() = CommonMainString0.range_festive_notice

private fun init_range_festive_notice(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:range_festive_notice", "range_festive_notice",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10282,
    100),
    )
)

internal val Res.string.rate_label_header: StringResource
  get() = CommonMainString0.rate_label_header

private fun init_rate_label_header(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:rate_label_header", "rate_label_header",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7329, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10869, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7392, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7457, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7197, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7485, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10165, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6625, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10383,
    37),
    )
)

internal val Res.string.rate_label_pharmacist: StringResource
  get() = CommonMainString0.rate_label_pharmacist

private fun init_rate_label_pharmacist(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:rate_label_pharmacist", "rate_label_pharmacist",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7363, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10907, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7426, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7491, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7231, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7519, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10207, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6659, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10421,
    49),
    )
)

internal val Res.string.rate_label_pharmacy: StringResource
  get() = CommonMainString0.rate_label_pharmacy

private fun init_rate_label_pharmacy(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:rate_label_pharmacy", "rate_label_pharmacy",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7409, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    10977, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7476, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7537, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7285, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7569, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10269, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6709, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10471,
    43),
    )
)

internal val Res.string.received_from: StringResource
  get() = CommonMainString0.received_from

private fun init_received_from(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:received_from", "received_from",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7457, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11045, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7520, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7581, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7333, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7617, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10337, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6757, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10515,
    37),
    )
)

internal val Res.string.region_label: StringResource
  get() = CommonMainString0.region_label

private fun init_region_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:region_label", "region_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7564, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11204, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7631, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7696, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7444, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7732, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10472, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6864, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10630,
    32),
    )
)

internal val Res.string.region_label_caps: StringResource
  get() = CommonMainString0.region_label_caps

private fun init_region_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:region_label_caps", "region_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7495, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11095, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7562, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7619, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7367, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7655, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10387, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6795, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10553,
    37),
    )
)

internal val Res.string.region_label_short: StringResource
  get() = CommonMainString0.region_label_short

private fun init_region_label_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:region_label_short", "region_label_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7529, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11149, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7596, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7657, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7405, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7693, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10429, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6829, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10591,
    38),
    )
)

internal val Res.string.register_button_caps: StringResource
  get() = CommonMainString0.register_button_caps

private fun init_register_button_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:register_button_caps", "register_button_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7597, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11257, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7664, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7729, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7477, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7765, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10513, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6897, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10663,
    44),
    )
)

internal val Res.string.register_title_screen: StringResource
  get() = CommonMainString0.register_title_screen

private fun init_register_title_screen(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:register_title_screen", "register_title_screen",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7642, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11306, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7705, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7774, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7522, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7806, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10590, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6934, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10708,
    45),
    )
)

internal val Res.string.registration_success_message: StringResource
  get() = CommonMainString0.registration_success_message

private fun init_registration_success_message(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:registration_success_message", "registration_success_message",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7692, 112),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11396, 168),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7755, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7820, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7576, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7852, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10660, 136),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6980, 92),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10754,
    92),
    )
)

internal val Res.string.registration_success_title: StringResource
  get() = CommonMainString0.registration_success_title

private fun init_registration_success_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:registration_success_title", "registration_success_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7805, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11565, 94),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7848, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7913, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7665, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7945, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10797, 90),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7073, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10847,
    70),
    )
)

internal val Res.string.reject_button: StringResource
  get() = CommonMainString0.reject_button

private fun init_reject_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:reject_button", "reject_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7880, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11660, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7915, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7980, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7732, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8008, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10888, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7128, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10918,
    33),
    )
)

internal val Res.string.release_shift_button: StringResource
  get() = CommonMainString0.release_shift_button

private fun init_release_shift_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:release_shift_button", "release_shift_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10952,
    44),
    )
)

internal val Res.string.remember_me_label: StringResource
  get() = CommonMainString0.remember_me_label

private fun init_remember_me_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:remember_me_label", "remember_me_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 10997,
    69),
    )
)

internal val Res.string.remove_button: StringResource
  get() = CommonMainString0.remove_button

private fun init_remove_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:remove_button", "remove_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7914, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11706, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7945, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8014, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7766, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8042, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10934, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7158, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11067,
    33),
    )
)

internal val Res.string.remove_favorites: StringResource
  get() = CommonMainString0.remove_favorites

private fun init_remove_favorites(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:remove_favorites", "remove_favorites",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7948, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11752, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    7975, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8044, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7800, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8076, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10976, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7188, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11101,
    52),
    )
)

internal val Res.string.reputation_insufficient_data: StringResource
  get() = CommonMainString0.reputation_insufficient_data

private fun init_reputation_insufficient_data(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:reputation_insufficient_data", "reputation_insufficient_data",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8005, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11837, 124),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8028, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8097, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7853, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8129, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11057, 128),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7237, 84),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11154,
    84),
    )
)

internal val Res.string.reputation_title: StringResource
  get() = CommonMainString0.reputation_title

private fun init_reputation_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:reputation_title", "reputation_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8098, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    11962, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8113, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8186, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7946, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8218, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11186, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7322, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11239,
    48),
    )
)

internal val Res.string.reset_filters: StringResource
  get() = CommonMainString0.reset_filters

private fun init_reset_filters(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:reset_filters", "reset_filters",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8135, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12011, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8158, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8231, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7995, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8263, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11247, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7363, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11288,
    41),
    )
)

internal val Res.string.saturday: StringResource
  get() = CommonMainString0.saturday

private fun init_saturday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:saturday", "saturday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8185, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12077, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8200, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8281, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8049, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8305, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11313, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7401, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11330,
    24),
    )
)

internal val Res.string.save_button: StringResource
  get() = CommonMainString0.save_button

private fun init_save_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:save_button", "save_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8214, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12114, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8229, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8310, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8074, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8334, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11350, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7430, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11355,
    27),
    )
)

internal val Res.string.save_changes: StringResource
  get() = CommonMainString0.save_changes

private fun init_save_changes(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:save_changes", "save_changes",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8246, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12162, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8257, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8342, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8110, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8362, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11394, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7458, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11383,
    40),
    )
)

internal val Res.string.search_pharmacies_subtitle: StringResource
  get() = CommonMainString0.search_pharmacies_subtitle

private fun init_search_pharmacies_subtitle(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:search_pharmacies_subtitle", "search_pharmacies_subtitle",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8295, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12231, 154),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8294, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8383, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8171, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8411, 90),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11467, 134),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7495, 86),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11424,
    86),
    )
)

internal val Res.string.search_pharmacies_title: StringResource
  get() = CommonMainString0.search_pharmacies_title

private fun init_search_pharmacies_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:search_pharmacies_title", "search_pharmacies_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8366, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12386, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8377, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8470, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8246, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8502, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11602, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7582, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11511,
    55),
    )
)

internal val Res.string.search_pharmacists_title: StringResource
  get() = CommonMainString0.search_pharmacists_title

private fun init_search_pharmacists_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:search_pharmacists_title", "search_pharmacists_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8418, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12470, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8433, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8526, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8314, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8562, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11662, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7630, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11567,
    56),
    )
)

internal val Res.string.select_at_least_one_date: StringResource
  get() = CommonMainString0.select_at_least_one_date

private fun init_select_at_least_one_date(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:select_at_least_one_date", "select_at_least_one_date",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8475, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12563, 124),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8490, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8587, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8379, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8627, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11739, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7683, 68),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11624,
    68),
    )
)

internal val Res.string.select_availability_range: StringResource
  get() = CommonMainString0.select_availability_range

private fun init_select_availability_range(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:select_availability_range", "select_availability_range",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8552, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12688, 109),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8555, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8660, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8456, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8700, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11836, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7752, 61),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11693,
    77),
    )
)

internal val Res.string.select_button: StringResource
  get() = CommonMainString0.select_button

private fun init_select_button(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:select_button", "select_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8610, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12798, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8625, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8738, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8538, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8786, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11942, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7814, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11771,
    33),
    )
)

internal val Res.string.select_dates: StringResource
  get() = CommonMainString0.select_dates

private fun init_select_dates(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:select_dates", "select_dates",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8648, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12840, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8655, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8776, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8580, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8824, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11984, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7844, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11805,
    40),
    )
)

internal val Res.string.select_language: StringResource
  get() = CommonMainString0.select_language

private fun init_select_language(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:select_language", "select_language",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8693, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12913, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8692, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8821, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8629, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8869, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12037, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7881, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11846,
    47),
    )
)

internal val Res.string.select_period_title: StringResource
  get() = CommonMainString0.select_period_title

private fun init_select_period_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:select_period_title", "select_period_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11894,
    51),
    )
)

internal val Res.string.select_role: StringResource
  get() = CommonMainString0.select_role

private fun init_select_role(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:select_role", "select_role",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8737, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    12977, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8736, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8869, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8677, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8917, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12097, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7921, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11946,
    39),
    )
)

internal val Res.string.select_shift_range: StringResource
  get() = CommonMainString0.select_shift_range

private fun init_select_shift_range(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:select_shift_range", "select_shift_range",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8781, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13033, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8772, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8909, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8729, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8965, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12153, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7957, 50),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 11986,
    58),
    )
)

internal val Res.string.selected_count_label: StringResource
  get() = CommonMainString0.selected_count_label

private fun init_selected_count_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:selected_count_label", "selected_count_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12045,
    52),
    )
)

internal val Res.string.send_report_button: StringResource
  get() = CommonMainString0.send_report_button

private fun init_send_report_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:send_report_button", "send_report_button",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8840, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13116, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8823, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8968, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8792, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9032, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12236, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8008, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12098,
    50),
    )
)

internal val Res.string.sent_by: StringResource
  get() = CommonMainString0.sent_by

private fun init_sent_by(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:sent_by", "sent_by",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8887, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13195, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8866, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9015, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8831, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9083, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12303, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8051, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12183,
    31),
    )
)

internal val Res.string.sent_by_short: StringResource
  get() = CommonMainString0.sent_by_short

private fun init_sent_by_short(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:sent_by_short", "sent_by_short",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12149,
    33),
    )
)

internal val Res.string.settings_title: StringResource
  get() = CommonMainString0.settings_title

private fun init_settings_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:settings_title", "settings_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8919, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13243, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8894, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9047, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8863, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9115, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12347, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8079, 30),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12215,
    38),
    )
)

internal val Res.string.shifts_ready_to_publish: StringResource
  get() = CommonMainString0.shifts_ready_to_publish

private fun init_shifts_ready_to_publish(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:shifts_ready_to_publish", "shifts_ready_to_publish",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8962, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13290, 111),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    8929, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9082, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8902, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9154, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12394, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8110, 63),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12254,
    79),
    )
)

internal val Res.string.single_date_caps: StringResource
  get() = CommonMainString0.single_date_caps

private fun init_single_date_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:single_date_caps", "single_date_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12334,
    40),
    )
)

internal val Res.string.skills_filter_label: StringResource
  get() = CommonMainString0.skills_filter_label

private fun init_skills_filter_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:skills_filter_label", "skills_filter_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12375,
    55),
    )
)

internal val Res.string.start_label: StringResource
  get() = CommonMainString0.start_label

private fun init_start_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:start_label", "start_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9042, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13402, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9001, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9154, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8978, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9230, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12490, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8174, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12431,
    27),
    )
)

internal val Res.string.status_accepted: StringResource
  get() = CommonMainString0.status_accepted

private fun init_status_accepted(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:status_accepted", "status_accepted",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9070, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13438, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9029, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9182, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9006, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9262, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12526, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8202, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12500,
    35),
    )
)

internal val Res.string.status_accepted_caps: StringResource
  get() = CommonMainString0.status_accepted_caps

private fun init_status_accepted_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:status_accepted_caps", "status_accepted_caps",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12459,
    40),
    )
)

internal val Res.string.status_cancelled: StringResource
  get() = CommonMainString0.status_cancelled

private fun init_status_cancelled(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:status_cancelled", "status_cancelled",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9110, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13486, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9065, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9218, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9042, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9294, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12570, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8238, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12536,
    36),
    )
)

internal val Res.string.status_confirmed: StringResource
  get() = CommonMainString0.status_confirmed

private fun init_status_confirmed(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:status_confirmed", "status_confirmed",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9147, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13535, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9102, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9255, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9079, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9331, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12619, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8275, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12573,
    48),
    )
)

internal val Res.string.status_in_progress: StringResource
  get() = CommonMainString0.status_in_progress

private fun init_status_in_progress(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:status_in_progress", "status_in_progress",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12622,
    38),
    )
)

internal val Res.string.status_proposed: StringResource
  get() = CommonMainString0.status_proposed

private fun init_status_proposed(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:status_proposed", "status_proposed",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9196, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13612, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9139, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9304, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9128, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9380, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12692, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8320, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12661,
    35),
    )
)

internal val Res.string.status_rejected: StringResource
  get() = CommonMainString0.status_rejected

private fun init_status_rejected(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:status_rejected", "status_rejected",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9240, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13668, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9175, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9340, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9164, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9416, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12744, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8356, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12697,
    35),
    )
)

internal val Res.string.status_waiting: StringResource
  get() = CommonMainString0.status_waiting

private fun init_status_waiting(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:status_waiting", "status_waiting",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9276, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13720, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9211, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9376, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9200, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9452, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12792, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8392, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12733,
    34),
    )
)

internal val Res.string.storico_title: StringResource
  get() = CommonMainString0.storico_title

private fun init_storico_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:storico_title", "storico_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12768,
    53),
    )
)

internal val Res.string.sunday: StringResource
  get() = CommonMainString0.sunday

private fun init_sunday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:sunday", "sunday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9311, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13771, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9246, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9411, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9239, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9507, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12839, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8427, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12822,
    26),
    )
)

internal val Res.string.support_alternative: StringResource
  get() = CommonMainString0.support_alternative

private fun init_support_alternative(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_alternative", "support_alternative",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9338, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13806, 143),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9269, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9438, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9266, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9534, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12886, 151),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8454, 75),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12849,
    87),
    )
)

internal val Res.string.support_email_body: StringResource
  get() = CommonMainString0.support_email_body

private fun init_support_email_body(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_email_body", "support_email_body",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9406, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    13950, 210),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9353, 146),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9514, 154),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9326, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9626, 166),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13038, 234),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8530, 150),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 12937,
    154),
    )
)

internal val Res.string.support_email_subject: StringResource
  get() = CommonMainString0.support_email_subject

private fun init_support_email_subject(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_email_subject", "support_email_subject",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9453, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14161, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9500, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9669, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9373, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9793, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13273, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8681, 77),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13092,
    73),
    )
)

internal val Res.string.support_feedback: StringResource
  get() = CommonMainString0.support_feedback

private fun init_support_feedback(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_feedback", "support_feedback",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9571, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14287, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9618, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9787, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9491, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9911, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13395, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8799, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13210,
    52),
    )
)

internal val Res.string.support_feedback_option: StringResource
  get() = CommonMainString0.support_feedback_option

private fun init_support_feedback_option(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_feedback_option", "support_feedback_option",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9527, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14239, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9574, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9743, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9447, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9867, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13347, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8759, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13166,
    43),
    )
)

internal val Res.string.support_intro: StringResource
  get() = CommonMainString0.support_intro

private fun init_support_intro(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:support_intro", "support_intro",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9624, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14368, 233),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9667, 121),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9836, 133),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9544, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9960, 133),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13468, 221),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8844, 121),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13263,
    133),
    )
)

internal val Res.string.support_message_label: StringResource
  get() = CommonMainString0.support_message_label

private fun init_support_message_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_message_label", "support_message_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9718, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14602, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9789, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9970, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9634, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10094, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13690, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8966, 57),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13397,
    69),
    )
)

internal val Res.string.support_message_placeholder: StringResource
  get() = CommonMainString0.support_message_placeholder

private fun init_support_message_placeholder(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_message_placeholder", "support_message_placeholder",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9772, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14696, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9851, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10032, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9688, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10160, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13780, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9024, 71),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13467,
    67),
    )
)

internal val Res.string.support_other_option: StringResource
  get() = CommonMainString0.support_other_option

private fun init_support_other_option(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_other_option", "support_other_option",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9840, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14804, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9923, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10108, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9744, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10232, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13876, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9096, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13535,
    36),
    )
)

internal val Res.string.support_report_option: StringResource
  get() = CommonMainString0.support_report_option

private fun init_support_report_option(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_report_option", "support_report_option",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9881, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14845, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    9960, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10145, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9781, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10269, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13921, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9133, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13572,
    57),
    )
)

internal val Res.string.support_technical_option: StringResource
  get() = CommonMainString0.support_technical_option

private fun init_support_technical_option(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_technical_option", "support_technical_option",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9923, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14919, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10006, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10199, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9827, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10331, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14007, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9179, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13630,
    56),
    )
)

internal val Res.string.support_title: StringResource
  get() = CommonMainString0.support_title

private fun init_support_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:support_title", "support_title",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9984, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    14996, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10059, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10256, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9888, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10388, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14092, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9228, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13687,
    49),
    )
)

internal val Res.string.support_type_label: StringResource
  get() = CommonMainString0.support_type_label

private fun init_support_type_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:support_type_label", "support_type_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10034, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15074, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10109, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10302, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9938, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10434, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14162, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9270, 46),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13737,
    42),
    )
)

internal val Res.string.surname_label: StringResource
  get() = CommonMainString0.surname_label

private fun init_surname_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:surname_label", "surname_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10112, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15172, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10191, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10384, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10012, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10516, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14252, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9352, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13819,
    33),
    )
)

internal val Res.string.surname_label_caps: StringResource
  get() = CommonMainString0.surname_label_caps

private fun init_surname_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:surname_label_caps", "surname_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10073, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15125, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10152, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10345, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9981, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10477, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14205, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9317, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13780,
    38),
    )
)

internal val Res.string.surname_row: StringResource
  get() = CommonMainString0.surname_row

private fun init_surname_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:surname_row", "surname_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10146, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15214, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10225, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10418, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10038, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10550, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14294, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9382, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13853,
    31),
    )
)

internal val Res.string.tab_ads: StringResource
  get() = CommonMainString0.tab_ads

private fun init_tab_ads(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tab_ads", "tab_ads",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10178, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15254, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10257, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10450, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10062, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10582, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14334, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9410, 23),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13885,
    27),
    )
)

internal val Res.string.tab_home: StringResource
  get() = CommonMainString0.tab_home

private fun init_tab_home(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tab_home", "tab_home",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10206, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15294, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10277, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10478, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10090, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10610, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14378, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9434, 24),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13913,
    24),
    )
)

internal val Res.string.tab_profile: StringResource
  get() = CommonMainString0.tab_profile

private fun init_tab_profile(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tab_profile", "tab_profile",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10231, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15327, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10302, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10503, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10119, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10639, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14415, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9459, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13938,
    31),
    )
)

internal val Res.string.tab_search: StringResource
  get() = CommonMainString0.tab_search

private fun init_tab_search(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tab_search", "tab_search",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10259, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15363, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10334, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10531, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10147, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10667, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14455, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9487, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13970,
    26),
    )
)

internal val Res.string.tax_code_error_invalid: StringResource
  get() = CommonMainString0.tax_code_error_invalid

private fun init_tax_code_error_invalid(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tax_code_error_invalid", "tax_code_error_invalid",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10286, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15406, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10361, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10558, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10178, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10698, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14490, 126),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9514, 66),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 13997,
    86),
    )
)

internal val Res.string.tax_code_error_length: StringResource
  get() = CommonMainString0.tax_code_error_length

private fun init_tax_code_error_length(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tax_code_error_length", "tax_code_error_length",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10341, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15473, 141),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10436, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10625, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10233, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10749, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14617, 133),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9581, 69),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14084,
    93),
    )
)

internal val Res.string.tax_code_label: StringResource
  get() = CommonMainString0.tax_code_label

private fun init_tax_code_label(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tax_code_label", "tax_code_label",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10459, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15651, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10550, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10747, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10355, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10851, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14787, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9687, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14214,
    46),
    )
)

internal val Res.string.tax_code_label_caps: StringResource
  get() = CommonMainString0.tax_code_label_caps

private fun init_tax_code_label_caps(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tax_code_label_caps", "tax_code_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10423, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15615, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10510, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10715, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10315, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10819, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14751, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9651, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14178,
    35),
    )
)

internal val Res.string.tax_code_row: StringResource
  get() = CommonMainString0.tax_code_row

private fun init_tax_code_row(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tax_code_row", "tax_code_row",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10502, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15686, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10593, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10782, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10398, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10882, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14846, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9722, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14261,
    40),
    )
)

internal val Res.string.thursday: StringResource
  get() = CommonMainString0.thursday

private fun init_thursday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:thursday", "thursday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10539, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15715, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10626, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10815, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10435, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10907, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14903, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9751, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14302,
    28),
    )
)

internal val Res.string.time_active_now: StringResource
  get() = CommonMainString0.time_active_now

private fun init_time_active_now(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:time_active_now", "time_active_now",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14331,
    39),
    )
)

internal val Res.string.time_label_header: StringResource
  get() = CommonMainString0.time_label_header

private fun init_time_label_header(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:time_label_header", "time_label_header",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10572, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15748, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10655, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10840, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10460, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10940, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14940, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9780, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14371,
    33),
    )
)

internal val Res.string.time_remaining: StringResource
  get() = CommonMainString0.time_remaining

private fun init_time_remaining(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:time_remaining", "time_remaining",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14405,
    34),
    )
)

internal val Res.string.total_per_shift: StringResource
  get() = CommonMainString0.total_per_shift

private fun init_total_per_shift(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:total_per_shift", "total_per_shift",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10610, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15782, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10689, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10878, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10498, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10978, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14982, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9814, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14440,
    39),
    )
)

internal val Res.string.tuesday: StringResource
  get() = CommonMainString0.tuesday

private fun init_tuesday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tuesday", "tuesday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10654, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15842, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10729, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10918, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10538, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11018, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15042, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9858, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14480,
    27),
    )
)

internal val Res.string.type_min_chars: StringResource
  get() = CommonMainString0.type_min_chars

private fun init_type_min_chars(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:type_min_chars", "type_min_chars",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10682, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    15874, 126),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10757, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10942, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10562, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11050, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15078, 90),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9886, 62),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14508,
    62),
    )
)

internal val Res.string.user_not_logged_in: StringResource
  get() = CommonMainString0.user_not_logged_in

private fun init_user_not_logged_in(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:user_not_logged_in", "user_not_logged_in",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10749, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16001, 106),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10820, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11009, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10629, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11117, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15169, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9949, 46),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14571,
    50),
    )
)

internal val Res.string.vat_label_caps: StringResource
  get() = CommonMainString0.vat_label_caps

private fun init_vat_label_caps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:vat_label_caps", "vat_label_caps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10812, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16108, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10871, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11064, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10692, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11180, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15252, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9996, 38),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14622,
    30),
    )
)

internal val Res.string.vat_number: StringResource
  get() = CommonMainString0.vat_number

private fun init_vat_number(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:vat_number", "vat_number",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10847, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16139, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10898, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11091, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10719, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11207, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15283, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10035, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14653,
    34),
    )
)

internal val Res.string.view_in_calendar: StringResource
  get() = CommonMainString0.view_in_calendar

private fun init_view_in_calendar(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:view_in_calendar", "view_in_calendar",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10878, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16166, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10933, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11122, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10754, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11230, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15330, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10090, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14688,
    52),
    )
)

internal val Res.string.waiting_counterparty: StringResource
  get() = CommonMainString0.waiting_counterparty

private fun init_waiting_counterparty(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:waiting_counterparty", "waiting_counterparty",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10927, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16247, 148),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    10982, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11171, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10811, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11279, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15411, 116),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10139, 56),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14741,
    84),
    )
)

internal val Res.string.waiting_final_confirmation: StringResource
  get() = CommonMainString0.waiting_final_confirmation

private fun init_waiting_final_confirmation(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:waiting_final_confirmation", "waiting_final_confirmation",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11004, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16396, 174),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11067, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11252, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10884, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11360, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15528, 170),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10196, 78),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14826,
    102),
    )
)

internal val Res.string.wednesday: StringResource
  get() = CommonMainString0.wednesday

private fun init_wednesday(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:wednesday", "wednesday",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11083, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16571, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11166, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11351, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10967, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11459, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15699, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10275, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14929,
    33),
    )
)

internal val Res.string.welcome: StringResource
  get() = CommonMainString0.welcome

private fun init_welcome(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:welcome", "welcome",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11158, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16674, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11229, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11422, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11030, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11526, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15790, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10342, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14996,
    31),
    )
)

internal val Res.string.welcome_back: StringResource
  get() = CommonMainString0.welcome_back

private fun init_welcome_back(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:welcome_back", "welcome_back",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11113, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16609, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11196, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11385, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10997, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11493, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15733, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10305, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 14963,
    32),
    )
)

internal val Res.string.yes: StringResource
  get() = CommonMainString0.yes

private fun init_yes(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:yes", "yes",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11257, 15),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 15063,
    15),
    )
)

internal val Res.string.yes_cancel: StringResource
  get() = CommonMainString0.yes_cancel

private fun init_yes_cancel(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:yes_cancel", "yes_cancel",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 15028,
    34),
    )
)

internal val Res.string.your_active_ads: StringResource
  get() = CommonMainString0.your_active_ads

private fun init_your_active_ads(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:your_active_ads", "your_active_ads",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11190, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16722, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11273, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11454, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11062, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11558, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15850, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10370, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 15079,
    51),
    )
)

internal val Res.string.your_proposal: StringResource
  get() = CommonMainString0.your_proposal

private fun init_your_proposal(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:your_proposal", "your_proposal",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11242, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16806, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11317, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11506, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11114, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11610, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15938, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10418, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 15131,
    37),
    )
)

internal val Res.string.zone_label_header: StringResource
  get() = CommonMainString0.zone_label_header

private fun init_zone_label_header(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:zone_label_header", "zone_label_header",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11284, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("el"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-el/strings.commonMain.cvr",
    16860, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("en"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-en/strings.commonMain.cvr",
    11359, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11544, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11160, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11648, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    16004, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ), "composeResources/farmatch.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10456, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/values/strings.commonMain.cvr", 15169,
    33),
    )
)
